import classnames from "classnames";
import copy from 'copy-to-clipboard';
import fixOrientation from "fix-orientation";
import _ from 'lodash';
import moment, { now } from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink, withRouter } from "react-router-dom";
import Select from "react-select";
import { fetchAnimalTypes } from "../../../actions/addAnimalType";
import { fetchBreedInfo, fetchBreedTypesByAnimal, fetchUpdatedBreedTypeById } from "../../../actions/addBreedType";
import {
  attachMRAvatar, createWooPet, deleteMedication, fetchContractFromWooStore, fetchMedicalRecords, findPetById,
  removePuppyVideo, showMedicalRecord, updateMedicalRecord, updatePrintMRecord, updateWooPageStatus,
  updateVideoCallStatus,petPinToTop,deleteProfileImage,
} from "../../../actions/medicalRecords";
import { getNotificationsByMedicalRecord } from "../../../actions/subscribeToPet";
import Switch from "react-switch";
import Vimeo from '@u-wave/react-vimeo';
import axios from 'axios';
import AvatarEditor from "react-avatar-editor";
import DatePicker from "react-datepicker";
import { NotificationManager } from "react-notifications";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import Slider from "react-rangeslider";
import "react-rangeslider/lib/index.css";
import { fetchAdministereds } from "../../../actions/administered";
import { fetchBreedCategory, fetchBreeders } from "../../../actions/breeders";
import { getConfigByName } from "../../../actions/configuration";
import { fetchFoodTypes } from "../../../actions/foodType";
import { fetchRegTypes } from "../../../actions/regType";
import { BreadCrumb } from "../../../components/breadcrumb";
import { Loader } from "../../../components/loader";
import MRecordPDF from "../../../components/mRecordPdf/mRecordEditPdf";
import Video from '../../../components/videoPlayer/wistia';
import config from "../../../config";
import { forceInputUppercase, resizeImage } from "../../../utils/helper";
import AddBreedTypeForm from "../../settings/addBreedType";
import AddMedicationForm from "./addMedication";
import PetNameSuggestion from '../../../components/openAi/nameSuggestionModal';
import PetDescriptionSuggestion from '../../../components/openAi/petDescriptionSuggestionModal';
import PetZodiacDescriptionSuggestion from "../../../components/openAi/petZodiacDescriptionSuggestionModal";
import zodiacData from '../../../zodiacData.json';

const $ = window.$;
const scroll = {};
let edit_form = {};
let breeder_form = {};
let loadflag = false;
const videoHoster = {
  vimeo : "vimeo",
  wistia : "wistia",
};

const soldReasonValues = [
  {
    key: "sold-by-the-breeder",
    value: "Sold by the Breeder",
    notify: true
  },
  {
    key: "on-medical-treatment",
    value: "On Medical Treatment",
    notify: false
  },
  {
    key: "financing",
    value: "Financing",
    notify: false
  },
  {
    key: "on-hold",
    value: "On Hold",
    notify: false
  }
];

class MRecordsListView extends Component {
  constructor(props) {
    super(props);
  }

  wooPageStatusOptions = {
    Public: "public",
    Finance: "finance",
    Private: "private"
  }

  wooPagePuppyStatusOptions = {
    Sold: "sold",
    Available: "available"
  }

  state = {

    mediModalType: "",
    currentFormNotValid: false,
    mRecords: [],
    mRecord: {
      Breed: {},
      Pet: {},
      Registration_type: {},
      Breeder: {},
      MedicalRecordMedications: []
    },
    BreederId: "",
    b_usada: "",
    b_address: "",
    b_phone: "",
    editBreeder: false,
    editInfo: false,
    arrival_date: "",
    color_markings: "",
    micro_chip: "",
    toa: [],
    breeds: [],
    reg_types: [],
    breeders: [],
    PetId: "",
    BreedId: "",
    date_of_birth: "",
    RegistrationTypeId: "",
    sex: "",
    weight: null,
    cross_breed: "",
    price: "",
    medications: [],
    newMedication: {},
    deleteMediId: null,
    loadingDelete: false,
    loadingDeleteVideo: false,
    loadingBreeder: false,
    loadingInfo: false,
    changeAvatar: false,
    recordCompleted: true,
    notes: "",
    editNote: false,
    loadingNote: false,
    new_breeder: false,
    new_b_name: "",
    new_b_phone: "",
    new_b_usda: "",
    new_b_address_line_1: "",
    new_b_address_line_2: "",
    new_b_address_city: "",
    new_b_address_state: "",
    new_b_address_country: "",
    new_b_address_postal_code: "",
    clickedId: "",
    loadingStore: false,
    adult_weight: null,
    breeds_category: [],
    BreedCategoryId: "",
    foodTypes : [],
    foodTypeImagePath : "",
    foodTypeImageName : "",
    FoodTypeId : null,
    selectedBreedData :{},
    breedUpdated : false ,
    validateArrivalDate : true,
    showArrivalDateValidateMessage : true,
    showDOBValidateMessage : true,
    petAgeOnArrival : "",
    personality_description : "",  
    personality_description_full : "",

    // Image 01
    imgSrc01: "",
    imgName01: "",
    zoom01: 1.5,
    editor01: "",
    rotate01: 0,

    // Image 02
    imgSrc02: "",
    imgName02: "",
    zoom02: 1.5,
    editor02: "",
    rotate02: 0,

    // Image 03
    imgSrc03: "",
    imgName03: "",
    zoom03: 1.5,
    editor03: "",
    rotate03: 0,

    // Image 04
    imgSrc04: "",
    imgName04: "",
    zoom04: 1.5,
    editor04: "",
    rotate04: 0,

    // Image 05
    imgSrc05: "",
    imgName05: "",
    zoom05: 1.5,
    editor05: "",
    rotate05: 0,

    // Image 06
    imgSrc06: "",
    imgName06: "",
    zoom06: 1.5,
    editor06: "",
    rotate06: 0,

    // Image 07
    imgSrc07: "",
    imgName07: "",
    zoom07: 1.5,
    editor07: "",
    rotate07: 0,

    // Image 08
    imgSrc08: "",
    imgName08: "",
    zoom08: 1.5,
    editor08: "",
    rotate08: 0,

    // Image 09
    imgSrc09: "",
    imgName09: "",
    zoom09: 1.5,
    editor09: "",
    rotate09: 0,

    // Image 10
    imgSrc10: "",
    imgName10: "",
    zoom10: 1.5,
    editor10: "",
    rotate10: 0,

    selectedPrimaryImageOption: "1",
    loadingMultipleImages: false,
    selectedWooPageStatusOption: this.wooPageStatusOptions.Public,
    selectedWooPagePuppyStatusOption: this.wooPagePuppyStatusOptions.Available,
    loadingWooPageStatus: false,
    redirect: false,
    prevPath: '',
    loading: false,
    availablePetId: true,
    loadingAvailableId: false,
    siredam_disable: false,  
    pet_name: "",
    pdfOldVersion: false,
    arrival_date_picker: "",
    dob_picker: "",
    notifySubscribers: false,
    updateData: {},
    updateAvatarData: {},
    priceUpdate: false,
    avatarUpdate: false,
    availableSubscribers : [],
    changeVideo: false,
    selectedVideoFile: null,
    loadingVideo: false,
    videoPlayer: false,
    updatedVideoUrl: null,
    updatedVideoId: null,
    updatedVideoWistiaId: null,
    updatedVideoVimeoId: null,
    video: false, 
    videoUploadingFlag: false,
    playStop: true,
    videoHoster: null,
    currentVideoSource: null,
    vimeoLoaded: true,
    medicalRecord: {},
    video_call_status: false,
    soldReason: null,
    customFormNotValid: false,
    pin_to_top_status: false,
    loadingPinToTop: false,
    isPinToTop: null,
    pin_to_top_final_status: false,
    newImgSrc:"",
    newZoom: 1,
    newRotate: 0,
    uploadedImages:[],
    deletingImage: false,
    selectedDeletableImage: {},
    petType : "",
    petBreedName:'',
    namePrompt : '',
    descriptionPrompt : '',
    zodiacDescriptionPrompt: '',
  };

  componentDidMount = (nextProps) => {
    this.setState({loading: true})
    // navigated!
    this.autoload();
  };

  autoload() {  
    this.props.fetchMedicalRecords();
    this.props.showMedicalRecord(this.props.match.params.id);
    this.props.fetchAnimalTypes();
    this.props.fetchRegTypes();
    this.props.fetchBreeders();
    this.props.fetchBreedCategory();
    this.props.fetchFoodTypes();
    this.props.getNotificationsByMedicalRecord(this.props.match.params.id);
    this.props.getConfigByName({name:"video_hoster"});
  };

  componentWillReceiveProps = async (nextProps) => {

    if (nextProps.stateData.addBreedTypeReducer.updateBreedType !== this.props.stateData.addBreedTypeReducer.updateBreedType) {  
      this.setState({breedUpdated : true});
      this.props.fetchUpdatedBreedTypeById(this.state.BreedId);           
    }

    if(nextProps.updatedBreedTypeById !== this.props.updatedBreedTypeById){
      let breedsCopy = this.state.breeds.map(breed => {
        if(breed.id === nextProps.updatedBreedTypeById.id){
            return { label: nextProps.updatedBreedTypeById.breed_type, value: nextProps.updatedBreedTypeById.id }
        }else{
            return breed;
        }  
      })   
      this.setState({breeds : breedsCopy , cross_breed : nextProps.updatedBreedTypeById.cross_breed ? "YES" : "NO"  , BreedCategoryId : nextProps.updatedBreedTypeById.BreedCategoryId, sire : !nextProps.updatedBreedTypeById.cross_breed ? nextProps.updatedBreedTypeById.breed_type : "" , dam : !nextProps.updatedBreedTypeById.cross_breed ? nextProps.updatedBreedTypeById.breed_type : ""  });
    }

    if(nextProps.breedInfo !== this.props.breedInfo && nextProps.breedInfo.id){ 
      this.setState({BreedCategoryId : nextProps.breedInfo.BreedCategory && nextProps.breedInfo.BreedCategory.id ? nextProps.breedInfo.BreedCategory.id : null  , cross_breed :  nextProps.breedInfo.cross_breed ? "YES" : "NO" , sire : !nextProps.breedInfo.cross_breed ? nextProps.breedInfo.breed_type : "" , dam : !nextProps.breedInfo.cross_breed ? nextProps.breedInfo.breed_type : "" });
  }
    if (nextProps.location !== this.props.location) {
      this.setState({ prevPath: this.props.location })
    }

    if (
      nextProps.toaError ||
      nextProps.reg_types_error ||
      nextProps.mRecordsError ||
      nextProps.breederListError
    ) {
      NotificationManager.error("Something went wrong.");
    }

    if (this.props.data.error !== nextProps.data.error) {
      NotificationManager.error("Something went wrong.");
      this.setState({
        loadingBreeder: false,
        editBreeder: false,
        new_breeder: false,
        loadingInfo: false,
        editInfo: false,
        loadingNote: false,
        editNote: false,
        loadingMultipleImages: false,
        loading: false
      });
      
      this.props.showMedicalRecord(this.props.match.params.id);
    }
    if (this.props.toa !== nextProps.toa) {
      let options = [];
      nextProps.toa.map(p => {
        options.push({ label: p.type, value: p.id });
      });
      this.setState({ toa: options });
    }

    if (this.props.breeds !== nextProps.breeds) {
      let options = [];
      nextProps.breeds.map(p => {
        options.push({ label: p.breed_type, value: p.id });
      });
      this.setState({ breeds: options });
    }

    if (this.props.reg_types !== nextProps.reg_types) {
      let options = [{ label: "Select an option", value: "N/A" }];
      nextProps.reg_types.map(p => {
        options.push({ label: p.type, value: p.id });
      });
      this.setState({ reg_types: options });
    }

    if (this.props.data.showRecord !== nextProps.data.showRecord) {

      this.setState({
        mRecord: nextProps.data.showRecord,
        BreederId: nextProps.data.showRecord.Breeder
          ? nextProps.data.showRecord.Breeder.id
          : null,
        loading: false,
        pdfOldVersion: nextProps.data.showRecord.configPdfVersion,  
        video_call_status: nextProps.data.showRecord.video_call_status ? true : false,
        pin_to_top_final_status : nextProps.data.showRecord.PetPinToTop ? nextProps.data.showRecord.PetPinToTop.is_pet_in_que ? true : false : false,   
        petBreedName : nextProps.data.showRecord.Breed.breed_type,   
      });
      if(nextProps.data.showRecord.FoodType && nextProps.data.showRecord.FoodType.avatar_path && nextProps.data.showRecord.FoodType.avatar_file_name){
        this.setState({foodTypeImagePath : nextProps.data.showRecord.FoodType.avatar_path , foodTypeImageName : nextProps.data.showRecord.FoodType.avatar_file_name});
      }
      if (nextProps.data.showRecord.mc_status === "draft") {
        this.setState({ recordCompleted: false });
      } 

      if (nextProps.data.showRecord) {
        let medicalRecord = nextProps.data.showRecord;
        this.setState({ medicalRecord, selectedPrimaryImageOption: '1', soldReason: medicalRecord.sold_reason });

        if (medicalRecord.avatar_path && medicalRecord.avatar_file_name) {
          const imageURL = `${process.env.REACT_APP_S3_PATH}/${medicalRecord.avatar_path}/${medicalRecord.avatar_file_name}`;
          const imageData = await this.getImageDataURL(imageURL);
          this.setState({ imgSrc01: imageData, imgName01: medicalRecord.avatar_title });
        }

        if (medicalRecord.image02_path && medicalRecord.image02_file_name) {
          const imageURL = `${process.env.REACT_APP_S3_PATH}/${medicalRecord.image02_path}/${medicalRecord.image02_file_name}`;
          const imageData = await this.getImageDataURL(imageURL);
          this.setState({ imgSrc02: imageData, imgName02: medicalRecord.image02_title });
        }

        if (medicalRecord.image03_path && medicalRecord.image03_file_name) {
          const imageURL = `${process.env.REACT_APP_S3_PATH}/${medicalRecord.image03_path}/${medicalRecord.image03_file_name}`;
          const imageData = await this.getImageDataURL(imageURL);
          this.setState({ imgSrc03: imageData, imgName03: medicalRecord.image03_title });
        }

        if (medicalRecord.image04_path && medicalRecord.image04_file_name) {
          const imageURL = `${process.env.REACT_APP_S3_PATH}/${medicalRecord.image04_path}/${medicalRecord.image04_file_name}`;
          const imageData = await this.getImageDataURL(imageURL);
          this.setState({ imgSrc04: imageData, imgName04: medicalRecord.image04_title });
        }

        if (medicalRecord.image05_path && medicalRecord.image05_file_name) {
          const imageURL = `${process.env.REACT_APP_S3_PATH}/${medicalRecord.image05_path}/${medicalRecord.image05_file_name}`;
          const imageData = await this.getImageDataURL(imageURL);
          this.setState({ imgSrc05: imageData, imgName05: medicalRecord.image05_title });
        }
      }   

      if(nextProps.data.showRecord.video_url && nextProps.data.showRecord.video_name){       
        this.setState({ 
        loadingVideo: false,
        changeVideo: false,
        videoPlayer: true,
        vimeoLoaded : true,
        updatedVideoUrl: nextProps.data.showRecord.video_url,   
        updatedVideoId: nextProps.data.showRecord.video_id,       
        currentVideoSource:nextProps.data.showRecord.video_source 
      });
      }

      if(!nextProps.data.showRecord.video_url){       
        this.setState({     
        videoPlayer: false,
        updatedVideoUrl: null,   
        updatedVideoId: null,       
        currentVideoSource: null, 
        vimeoLoaded : true,
      });
      }

      if(nextProps.data.showRecord.petImages && nextProps.data.showRecord.petImages.length > 0 ){     
         this.setState({ uploadedImages : nextProps.data.showRecord.petImages });
       }else{
         this.setState({ uploadedImages : [] });
         $("#delete_profile_pic").modal('hide');  
       }




    }

    if (this.props.data.wooPet !== nextProps.data.wooPet) {
      $("#confirm_store_modal").modal("hide");
      this.setState({ loadingStore: false });
      this.props.showMedicalRecord(this.props.match.params.id);
      NotificationManager.success("This Pet Added to Store Successfully");

    }

    if (this.props.breeders !== nextProps.breeders) {
      let options = [{ label: "No Breeder Information", value: "N/A" }];
      nextProps.breeders.map(p => {
        options.push({ label: p.breeder, value: p.id });
      });
      this.setState({ breeders: options });
    }

    if (this.props.administered !== nextProps.administered) {
      let options = [];
      nextProps.administered.map(p => {
        options.push({ label: p.name, value: p.id });
      });
      this.setState({ administered: options });
    }

    if (this.props.data.newMedication !== nextProps.data.newMedication) {
      this.props.showMedicalRecord(this.props.match.params.id);
    }

    if (this.props.data.deletedMedi !== nextProps.data.deletedMedi) {
      this.setState({ loadingDelete: false });
      this.props.showMedicalRecord(this.props.match.params.id);
      NotificationManager.success("Deleted Successfully");
      $("#confirm_delete_modal").modal("hide");
    }

    if (this.props.data.updatedMRecord !== nextProps.data.updatedMRecord) {
      this.setState({
        loadingBreeder: false,
        editBreeder: false,
        new_breeder: false,
        loadingInfo: false,
        editInfo: false,
        loadingNote: false,
        editNote: false,
        loadingMultipleImages: false , 
        validateArrivalDate : true,
        showArrivalDateValidateMessage : true,
        currentFormNotValid : false,
      });
      if(this.state.videoUploadingFlag){     
        this.setState({videoUploadingFlag: false, uploadPercentage: 0, videoPlayer: true, loadingVideo: false, changeVideo: false });
        NotificationManager.success("Video Updated Successfully");
        this.props.showMedicalRecord(this.props.match.params.id);
      }
      else{
        this.props.showMedicalRecord(this.props.match.params.id);
        NotificationManager.success("Updated Successfully");
      }    
    }

    if (this.props.data.newAvatar !== nextProps.data.newAvatar) {
      this.setState({ 
        changeAvatar: false, 
        loadingMultipleImages: false, 
      });
      this.resetExistingImages();
      this.props.showMedicalRecord(this.props.match.params.id);
      NotificationManager.success("Avatar Updated Successfully");
    }

    if (this.state.availableSubscribers !== nextProps.stateData.subscribeToPetReducer.subscribeToPetByMr) {
      this.setState({ availableSubscribers: nextProps.stateData.subscribeToPetReducer.subscribeToPetByMr });
    }

    if (nextProps.data.fetchContractStatus
      && this.props.data.fetchContractStatus !== nextProps.data.fetchContractStatus) {
      const SuccessCode = '200';
      const AlreadyContractAvailableCode = '210';
      const OrderNotAvailableCode = '220';
      const ErrorCode = '400';

      switch (nextProps.data.fetchContractStatus) {
        case SuccessCode:
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
          this.props.showMedicalRecord(this.props.match.params.id);
          NotificationManager.success("Contract Created Successfully");
          break;

        case AlreadyContractAvailableCode:
          NotificationManager.error("A Contract is already available");
          break;

        case OrderNotAvailableCode:
          NotificationManager.error("The Relevant Order is not Available in Woo Store");
          break;

        case ErrorCode:
          NotificationManager.error("Failed to Create the Contract");
          break;

        default:
          NotificationManager.error("Failed to Create the Contract");
          break;
      }
    }

    if (this.props.data.fetchContractStatusError !== nextProps.data.fetchContractStatusError) {
      NotificationManager.error("Failed to Create the Contract");
    }

    if (
      nextProps.data.wooPetError && this.props.data.wooPetError !== nextProps.data.wooPetError
    ) {
      $("#confirm_store_modal").modal("hide");
      this.setState({ loadingStore: false });     
      if(nextProps.data.wooPetError.message){
        NotificationManager.error(nextProps.data.wooPetError.message);      
      }else{
         NotificationManager.error("Faild to Add to Store");
      }
      this.props.showMedicalRecord(this.props.match.params.id);
    }

    if (nextProps.data.updateWooPageStatus != null && 
      this.props.data.updateWooPageStatus != nextProps.data.updateWooPageStatus) {
      const SuccessCode = 200;
      const ErrorCode = 400;

      if (nextProps.data.updateWooPageStatus === SuccessCode) {
        NotificationManager.success("Status Updated Successfully");

        if(this.state.soldReason && soldReasonValues.find(record => (record.key === this.state.soldReason && record.notify === true))){
          $("#send_notification_model").modal("hide");
          this.setState({ soldReason: null });
        }
        
        $("#woo_page_status_modal").modal("hide");
      } 
      else if (nextProps.data.updateWooPageStatus === ErrorCode) {
        NotificationManager.error("Failed to Update the Status");
        if(this.state.soldReason && soldReasonValues.find(record => (record.key === this.state.soldReason && record.notify === true))){
          $("#woo_page_status_modal").modal("show");
          $("#send_notification_model").modal("hide");
          this.setState({ soldReason: null });
        }
      }

      this.setState({ loadingWooPageStatus: false });
      this.props.showMedicalRecord(this.props.match.params.id);
    }

    if (nextProps.data.updatedMRecordError && this.props.data.updatedMRecordError !== nextProps.data.updatedMRecordError) {
      if (nextProps.data.updatedMRecordError.message && nextProps.data.updatedMRecordError.message.name === 'SequelizeUniqueConstraintError') {
        NotificationManager.error("Pet Id already exists");
        this.setState({ loadingInfo: false });
      }
      else if(nextProps.data.updatedMRecordError && !nextProps.data.updatedMRecordError.availablePet){      
        NotificationManager.error( nextProps.data.updatedMRecordError.message );
        this.setState({ loadingInfo: false });
      };
    }
    if (  nextProps.data.mRecords &&
       nextProps.data.mRecords.medicalRecords &&
       nextProps.data.mRecords.medicalRecords.length > 0 &&
      nextProps.data.mRecords.medicalRecords !==
      this.props.data.mRecords.medicalRecords
    ) {
      let records = nextProps.data.mRecords.medicalRecords;  
      records.sort((a, b) => (a.id > b.id ? -1 : 1));
      this.setState({
        contentData: records,
        loading: false,       
      });
    }

    if (
      nextProps.breeds_category &&
      this.props.breeds_category !== nextProps.breeds_category &&
      nextProps.breeds_category.length > 0
    ) {
      let options = [{ label: "Select Welcome Email", value: "none" }];
      nextProps.breeds_category.map(p => {
        options.push({ label: p.name, value: p.id });
      });
      this.setState({ breeds_category: options });
    }

    if (
      nextProps.foodTypes &&
      this.props.foodTypes !== nextProps.foodTypes &&
      nextProps.foodTypes.length > 0
    ) {
      let options = [{ label: "SELECT THE FOOD TYPE", value: "none" }];
      nextProps.foodTypes.map(f => {
        options.push({ label: f.title, value: f.id , foodTypeImagePath : f.avatar_path , foodTypeImageName : f.avatar_file_name});
      });
      this.setState({ foodTypes: options });
      }

    if(nextProps.data.existingPetError != null && this.props.data.existingPetError !== nextProps.data.existingPetError){
      this.setState({ availablePetId: nextProps.data.existingPetError.petAvailable, loadingAvailableId: false })     
      this.loadflag = false;
      NotificationManager.error(nextProps.data.existingPetError.message,'', 300);
 
     }
 
     if(nextProps.data.existingPet != null && this.props.data.existingPet !== nextProps.data.existingPet){
      this.setState({ availablePetId: nextProps.data.existingPet.petAvailable, loadingAvailableId: false  });   
      this.loadflag = false;
      NotificationManager.success(nextProps.data.existingPet.message,'',1000);
     }

     if (this.props.configStatus !== nextProps.configStatus) {
      let configs = nextProps.configStatus; 
      if(configs && configs.name == 'video_hoster'){
       this.setState({ videoHoster: configs.value });
      }                   
    } 
 
    if (this.props.data.deletePuppyVideo !== nextProps.data.deletePuppyVideo) {
      this.setState({ loadingDeleteVideo: false });
      NotificationManager.success("Video deleted successfully");
      $("#confirm_delete_video_modal").modal("hide");
      this.props.showMedicalRecord(this.props.match.params.id);
    }

    if (this.props.data.deletePuppyVideoError !== nextProps.data.deletePuppyVideoError) {
      this.setState({ loadingDeleteVideo: false });
      NotificationManager.error("Remove video failed");
    }

    if (this.props.data.videoCallStatus !== nextProps.data.videoCallStatus) {
      this.props.showMedicalRecord(this.props.match.params.id);
      NotificationManager.success("Video call status updated");
    }

    if (this.props.data.videoCallStatusError !== nextProps.data.videoCallStatusError) {
      if (nextProps.data.videoCallStatusError && nextProps.data.videoCallStatusError.details) {
        NotificationManager.error(nextProps.data.videoCallStatusError.details.message);
      }
    }

    if(nextProps.pinToTopQueue && this.props.pinToTopQueue !== nextProps.pinToTopQueue){     
        let upatePinToTop = nextProps.pinToTopQueue;
        if(upatePinToTop.status === 'create'){    
          NotificationManager.success("Woostore puppy added to Pin to top queue successfully.");
        }
        else{
          NotificationManager.success("Woostore puppy remove from Pin to top queue successfully.");
        }
        this.setState({ loadingPinToTop : false });    
        $('#pet_pin_to_top_modal').modal('hide');    
    }  

    if(nextProps.pinToTopQueueError && this.props.pinToTopQueueError !== nextProps.pinToTopQueueError){  
       this.setState({ loadingPinToTop : false });  
       NotificationManager.error("An error occurred while updating the Website pin to top queue.");  
      $('#pet_pin_to_top_modal').modal('hide');    
  }

    if(nextProps.data.updatedProfileImages !== this.props.data.updatedProfileImages ){
      this.setState({ deletingImage: false });
      NotificationManager.success("Profile image delete successfully");
      this.props.showMedicalRecord(this.props.match.params.id);
    }

    if(nextProps.data.updatedProfileImagesError !== this.props.data.updatedProfileImagesError ){
      this.setState({ deletingImage: false });  
      NotificationManager.error("An error occurred while deleting the profile images");
    }
    
  };

  changeDateFormat = (date, currentFormat, requestFormat) => {
    if (moment.isMoment(date)) {
      return date.format(requestFormat);
    } else {
      let currentDateArr = date.split("-");
      let currentFormatArr = currentFormat.split("-");
      let requestFormatArr = requestFormat.split("-");
  
      if (currentDateArr.length > 2 && currentFormatArr.length > 2 && requestFormatArr.length > 2) {
        let currentDD, currentMM, currentYYYY;
        for (let i = 0; i < currentFormatArr.length; i++) {
          if (currentFormatArr[i] === "DD") {
            currentDD = i;
          }
          if (currentFormatArr[i] === "MM") {
            currentMM = i;
          }
          if (currentFormatArr[i] === "YYYY") {
            currentYYYY = i;
          }
        }
  
        let newDate = "";
        
        let requestDD, requestMM, requestYYYY;
        for (let i = 0; i <= (requestFormatArr.length - 1); i++) {
          if (requestFormatArr[i] === "DD") {
            requestDD = currentDateArr[currentDD];
            newDate += requestDD;
            if ((requestFormatArr.length - 1) > i) {
              newDate += "-";
            }
          }
          if (requestFormatArr[i] === "MM") {
            requestMM = currentDateArr[currentMM];
            newDate += requestMM;
            if ((requestFormatArr.length - 1) > i) {
              newDate += "-";
            }
          }
          if (requestFormatArr[i] === "YYYY") {
            requestYYYY = currentDateArr[currentYYYY];
            newDate += requestYYYY;
            if ((requestFormatArr.length - 1) > i) {
              newDate += "-";
            }
          }
        }
        return newDate;
      }
    }
  }

  calculatePetAgeOnArrival = (arrivalDate) => {
    arrivalDate = this.changeDateFormat(arrivalDate, "MM-DD-YYYY", "YYYY-MM-DD");
    let petBirthDate = moment(this.state.date_of_birth).format("YYYY-MM-DD");
    let diffInDays = moment(arrivalDate).diff(petBirthDate , 'days');

    let amountWeeks = Math.floor((diffInDays)/7);
    let remainingDays = diffInDays % 7;
    remainingDays = remainingDays.toFixed(0);
    
    let msg = `${amountWeeks} weeks, ${remainingDays} days`
    if(diffInDays > 0){
      this.setState({petAgeOnArrival : msg})
    }else{
      this.setState({petAgeOnArrival : `Invalid arrival date`})
    }
  }

  componentDidUpdate = (prevProps, prevState) => {

    if(prevState.arrival_date !== this.state.arrival_date){
      this.calculatePetAgeOnArrival(this.state.arrival_date);
      if(this.arrivalDateIsValid(this.state.arrival_date)){
        this.setState({showArrivalDateValidateMessage : false});
      }else{
        this.setState({showArrivalDateValidateMessage : true});
       
      };
    }

    if(prevState.date_of_birth !== this.state.date_of_birth){
      if(this.dateOfBirthRangeIsValid(this.state.date_of_birth)){
        this.setState({showDOBValidateMessage : false});
      }else{
        this.setState({showDOBValidateMessage : true});
      }
      this.getZodiac(this.state.date_of_birth)
    }

    if (this.props.match.params.id) {
      if (this.state.prevPath !== this.props.location) {
        this.setState({loading: true})
        this.autoload();
        this.setState({ prevPath: this.props.location })
      }
    }

    if (prevState.PetId !== this.state.PetId) {
      this.props.fetchBreedTypesByAnimal(this.state.PetId);
    }
    // if(this.state.BreederId===null){
    //     this.setState({BreederId:"", recordCompleted:false});
    // }
    if (prevState.BreederId !== this.state.BreederId) {
      // debugger;
      this.props.breeders.map(b => {
        if (b.id === this.state.BreederId) {
          this.setState({
            b_usda: b.usda_no ? b.usda_no : "",
            b_phone: b.phone ? b.phone : "",
            b_address_line_1: b.addressLine1 ? b.addressLine1 : "",
            b_address_line_2: b.addressLine2 ? b.addressLine2 : "",
            b_address_city: b.addressCity ? b.addressCity : "",
            b_address_state: b.addressState ? b.addressState : "",
            b_address_country: b.addressCountry ? b.addressCountry : "",
            b_address_postal_code: b.addressPostalCode
              ? b.addressPostalCode
              : ""
          });
        }
      });
    }

    if (prevState.breeds !== this.state.breeds && !this.state.breedUpdated) {
      this.state.breeds.map(t => {
        if (t.label === this.state.mRecord.Breed.breed_type) {
          this.setState({ BreedId: t.value });
        }
      });
    }

    if (this.state.clickedId && this.state.clickedId !== prevState.clickedId) { 
      this.props.updatePrintMRecord(this.state.clickedId);
    }

    if (
      this.props.data.printMRecord &&
      prevProps.data.printMRecord !==
      this.props.data.printMRecord
    ) {
      this.childDownload();
    }
  };

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  };

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
  }

  openPdf = () => {
    // e.preventDefault();
    if (this.state.clickedId !== this.props.match.params.id) {
      this.setState({ clickedId: this.props.match.params.id });
    } else {
      if (this.props.data.printMRecord)
        this.childDownload();
    }
  };

  changeBreedCategory = selected => {
    if (selected) {    
      this.setState({ BreedCategoryId: selected.value });
    }
  };

  changeVideoCallStatus = (checked) => {
    if (this.state.mRecord && this.state.mRecord.id) {
      this.setState({ video_call_status: checked });
      let medicalRecordId = this.state.mRecord.id;
      let data = { video_call_status: checked, availablePetId: true };
      this.props.updateVideoCallStatus(medicalRecordId, data);
    }
  };

  changePinToTopStatus = (checked) => {
    if (this.state.mRecord && this.state.mRecord.id) {
      const status = checked;
      this.setState({ pin_to_top_status: checked, isPinToTop: status  });
      $('#pet_pin_to_top_modal').modal('show');
    }
  };

  handlePinToTopQueue(){
    const medicalRecordId = this.state.mRecord.id;
    const pinToTopCurrentStatus = this.state.pin_to_top_status;
    const status = this.state.pin_to_top_status ? 'create':'remove';
    this.setState({ loadingPinToTop : true, pin_to_top_final_status: pinToTopCurrentStatus });
    this.props.petPinToTop(medicalRecordId, status);
  }

  changeFoodType = selected => {
    if (selected) { 
      if(selected.label === "SELECT THE FOOD TYPE"){
        this.setState({ FoodTypeId: null, foodTypeImagePath : "" , foodTypeImageName : ""});
      }else{
      this.setState({ FoodTypeId: selected.value , foodTypeImagePath :selected.foodTypeImagePath , foodTypeImageName : selected.foodTypeImageName });
    }}
  }

  openConfirmStoreModal = id => {
    $("#confirm_store_modal").modal("show");
  };

  openWooPageStatusModal = id => {
    if (this.state.mRecord) {
      if (this.state.mRecord.woo_page_status) {
        this.setState({ selectedWooPageStatusOption: this.state.mRecord.woo_page_status,  selectedWooPagePuppyStatusOption: this.state.mRecord.woo_pet_availability });
      }
      else {
        this.setState({ selectedWooPageStatusOption: this.wooPageStatusOptions.Public });
      }
    }

    $("#woo_page_status_modal").modal("show");
  };

  changeWooPageStatusOption = (changedEvent) => {
    if (changedEvent && changedEvent.target && changedEvent.target.value) {
      this.setState({
        selectedWooPageStatusOption: changedEvent.target.value,
        selectedWooPagePuppyStatusOption: ''
      });
    }
    else {
      this.setState({
        selectedWooPageStatusOption: this.wooPageStatusOptions.Public,
        selectedWooPagePuppyStatusOption: ''
      });
    }
  };

  changeWooPagePuppyStatusOption = (changedEvent) => {
    if (changedEvent && changedEvent.target && changedEvent.target.value) {
      this.setState({
        selectedWooPagePuppyStatusOption: changedEvent.target.value,
        soldReason: null,
        currentFormNotValid: false
      });
    }
    else {
      this.setState({
        selectedWooPagePuppyStatusOption: this.wooPagePuppyStatusOptions.Available,
        currentFormNotValid: false
      });
    }
  };

  selectPuppyImageDelete = (image) => { 
    if(image){
      this.setState({ selectedDeletableImage : image });
    }else{
      NotificationManager.warning("Puppy image not found");
    }  
}

  setWooPageStatus = (notify) => {
    if(this.state.selectedWooPagePuppyStatusOption === this.wooPagePuppyStatusOptions.Sold && !this.state.soldReason || this.state.soldReason === "Select Reason"){
      this.setState({customFormNotValid: true});
      return false;
    }

    if ( this.state.mRecord.id
      && this.state.mRecord.woo_pet_id 
      && this.state.mRecord.woo_pet 
      && this.state.mRecord.mc_status === 'complete') {
        this.setState({ loadingWooPageStatus: true });
        this.props.updateWooPageStatus(this.state.mRecord.id, {
          wooPageStatus: this.state.selectedWooPageStatusOption,
          wooPagePuppyStatus: this.state.selectedWooPagePuppyStatusOption,
          wooPetId: this.state.mRecord.woo_pet_id,
          reason: this.state.soldReason ? this.state.soldReason : "",
          notifySubscribers: notify
        });
    }
  };

  copyWooPageUrl = () => {
    if (this.state.mRecord && this.state.mRecord.woo_permalink) {
      copy(this.state.mRecord.woo_permalink);
      NotificationManager.success("Copy to clipboard");
    }
  };

  addtoStore = () => {
    // e.preventDefault();
    this.setState({ loadingStore: true });
    if (!this.state.mRecord.woo_pet && this.state.mRecord.mc_status === 'complete') {
      this.props.createWooPet(this.props.match.params.id, this.state.notifySubscribers);
    }
  };

  acceptMethods(childDownload) {
    // Parent stores the method that the child passed
    this.childDownload = childDownload;
  }

  handleChildUnmount() {
    this.setState({ clickedId: false });
  }

  setEditorRef = editor => {
    if (editor) {
      this.setState({ editor: editor });
    }
  };

  changeZoom = val => {
    if (val) {
      this.setState({ zoom: val });
    }
  };

  removeImage = (event) => {
    event.preventDefault();
    let { id } = event.target;
    switch (id) {
      case "image01":
        this.setState({ imgSrc01: "", imgName01: "" }, () => {
          this.setState({ selectedPrimaryImageOption: this.getNextPrimaryImage() });
        });
        break;
      case "image02":
        this.setState({ imgSrc02: "", imgName02: "" }, () => {
          this.setState({ selectedPrimaryImageOption: this.getNextPrimaryImage() });
        });
        break;
      case "image03":
        this.setState({ imgSrc03: "", imgName03: "" }, () => {
          this.setState({ selectedPrimaryImageOption: this.getNextPrimaryImage() });
        });
        break;
      case "image04":
        this.setState({ imgSrc04: "", imgName04: "" }, () => {
          this.setState({ selectedPrimaryImageOption: this.getNextPrimaryImage() });
        });
        break;
      case "image05":
        this.setState({ imgSrc05: "", imgName05: "" }, () => {
          this.setState({ selectedPrimaryImageOption: this.getNextPrimaryImage() });
        });
        break;
      default:
        NotificationManager.error("Image data not fetched. Please refresh the page and try again");
        break;
    }
  };

  getNextPrimaryImage = () => {
    const { imgSrc01, imgSrc02, imgName03, imgName04, imgName05 } = this.state;
    let images = [imgSrc01, imgSrc02, imgName03, imgName04, imgName05];
    let newPrimaryImageOption = 1;

    for (let index = 1; index <= images.length; index++) {
      if (images[0]) {
        break;
      } else if (images[index]) {
        newPrimaryImageOption = index + 1;
        break;
      }
    }

    return newPrimaryImageOption.toString();
  };

  getImageDataURL = async (imageURL) => {
    let image = document.createElement("img");
    image.crossOrigin = "Anonymous";
    image.width = 1000;
    image.height = 1000;
    image.src = imageURL+"?"+ new Date().getTime();

    return new Promise((resolve, reject) => {
      image.addEventListener("load", function () {
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");

        canvas.width = image.width > 1000 ? 1000 : image.width;
        canvas.height = image.height > 1000 ? 1000 : image.height;

        ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

        let imageData = canvas.toDataURL("image/jpeg");
        return resolve(imageData);
      });
    }).then((data) => {
      return data;
    });
  };

  _onChange = () => {
    this.resetExistingImages();
    let empty = []
    this.editedImageArray= [];
  //  const videoAvailable = this.state.mRecord && this.state.mRecord.video_name && this.state.mRecord.video_url ? true : false;
    const maxUploadImageCount = this.state.mRecord && this.state.mRecord.video_name && this.state.mRecord.video_url  ? 9 : 10 ;
     this.setState({ loadedImages : [], duplicateImages : [] },
      ()=>{
        var files = this.refs.multipleImageUploader.files;   
        var fileNo = 0;
    
        if (!files || !files.length) {
          return false;
        }
    
        if (files.length > maxUploadImageCount) {
          NotificationManager.error(`You can only upload maximum of ${maxUploadImageCount} images only.`);
          return false;
        }
    
        for (var file of files) {
          fileNo++;
    
          switch (fileNo) {
            case 1:
              this.uploadImage01(file);
              break;
            case 2:
              this.uploadImage02(file);
              break;
            case 3:
              this.uploadImage03(file);
              break;
            case 4:
              this.uploadImage04(file);
              break;
            case 5:
              this.uploadImage05(file);
              break;
            case 6:
              this.uploadImage06(file);
              break;
            case 7:
              this.uploadImage07(file);
              break;
            case 8:
              this.uploadImage08(file);
              break;
            case 9:
              this.uploadImage09(file);
              break;
            case 10:
              this.uploadImage10(file);
              break;
            default:
              break;
          }
        }
   

      }
      );
 
  };

  resetExistingImages() {
    this.setState({

      newImgSrc: "",
      newZoom : 1.5,
      newRotate: 0,
      // Image 01
      imgSrc01: "",
      imgName01: "",
      zoom01: 1.5,
      editor01: "",
      rotate01: 0,

      // Image 02
      imgSrc02: "",
      imgName02: "",
      zoom02: 1.5,
      editor02: "",
      rotate02: 0,

      // Image 03
      imgSrc03: "",
      imgName03: "",
      zoom03: 1.5,
      editor03: "",
      rotate03: 0,

      // Image 04
      imgSrc04: "",
      imgName04: "",
      zoom04: 1.5,
      editor04: "",
      rotate04: 0,

      // Image 05
      imgSrc05: "",
      imgName05: "",
      zoom05: 1.5,
      editor05: "",
      rotate05: 0,

      // Image 06
      imgSrc06: "",
      imgName06: "",
      zoom05: 1.5,
      editor06: "",
      rotate06: 0,

      // Image 07
      imgSrc07: "",
      imgName07: "",
      zoom07: 1.5,
      editor07: "",
      rotate07: 0,

      // Image 08
      imgSrc08: "",
      imgName08: "",
      zoom08: 1.5,
      editor08: "",
      rotate08: 0,

      // Image 09
      imgSrc09: "",
      imgName09: "",
      zoom09: 1.5,
      editor09: "",
      rotate09: 0,

      // Image 09
      imgSrc09: "",
      imgName09: "",
      zoom09: 1.5,
      editor09: "",
      rotate09: 0,

      // Image 10
      imgSrc10: "",
      imgName10: "",
      zoom10: 1.5,
      editor10: "",
      rotate10: 0,
      selectedPrimaryImageOption: "1",
      loadedImages:[],
    });
  };

  openBreedNamesSuggestionModal = (e) => {
    e.preventDefault();
    let promptData = {   
       color_marking : this.state.color_markings ? this.state.color_markings : '',
       breed : this.state.petBreedName ? this.state.petBreedName : '',
       gender : this.state.sex ? this.state.sex : '',   
       date_of_birth : this.state.date_of_birth ? moment(this.state.date_of_birth).format("YYYY-MM-DD") :'', 
    }
    this.setState({ loadingPetNames : true, namePrompt : promptData });  
  };

  openBreedPersonalityDescriptionModal = (e) => {
    e.preventDefault();
    if(this.state.pet_name){
      if(this.state.petBreedName){
       let promptData = {
          breed : this.state.petBreedName ? this.state.petBreedName : '',
          name : this.state.pet_name ? this.state.pet_name  : '',
          date_of_birth : this.state.date_of_birth ? moment(this.state.date_of_birth).format("YYYY-MM-DD") : '',
          gender :  this.state.sex ? this.state.sex : '',
          adult_weight : this.state.adult_weight ? this.state.adult_weight : '',
          color_marking : this.state.color_markings ? this.state.color_markings : '',
          zodiac: this.state.pet_zodiac ? this.state.pet_zodiac: '',    
        }
        this.setState({ descriptionPrompt : promptData});   
      }else{
        NotificationManager.error("Pet's breed required to generate personality description");
      }
    }else{
      NotificationManager.error("Pet's name is required to generate personality description");
    }
  }

  openZodiacDescriptionModal = (e) => {
    e.preventDefault();
    if(this.state.pet_name){
      if(this.state.petBreedName){
        if( this.state.personality_description){
          if(this.state.pet_zodiac){
       let promptData = {
          breed : this.state.petBreedName ? this.state.petBreedName : '',
          name : this.state.pet_name ? this.state.pet_name  : '',          
          zodiac: this.state.pet_zodiac,              
          description: this.state.personality_description ? this.state.personality_description: null,      
        }
        this.setState({ zodiacDescriptionPrompt : promptData});  
        }else{
          NotificationManager.error("Pet's zodiac required to generate zodiac description");
        } 
       }else{
        NotificationManager.error("Pet's personality description required to generate zodiac description");
       }
      }else{
        NotificationManager.error("Pet's breed required to generate zodiac description");
      }
    }else{
      NotificationManager.error("Pet's name is required to generate zodiac description");
    }
  }

  getZodiac = (birthDay) => {
    const dob = birthDay ? moment(birthDay).format("YYYY-MM-DD") : this.state.date_of_birth ? moment(this.state.date_of_birth).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"); 
    const dateParts = dob.split('-');
    const month = parseInt(dateParts[1], 10);
    const day = parseInt(dateParts[2], 10);
    for (let i = 0; i < zodiacData.length; i++) {
      const zodiac = zodiacData[i];   
      if (
        (month === zodiac.startMonth && day >= zodiac.startDay) ||
        (month === zodiac.endMonth && day <= zodiac.endDay) ||
        (month > zodiac.startMonth && month < zodiac.endMonth)
      ) {  
       this.setState({ pet_zodiac: zodiac.zodiac})
      }
    }  
  }

  handlePetNameChildResponse = (petNameData) => {
    this.setState({ pet_name : petNameData });
  }

  handlePetDescriptionResponse = (petDescriptionData) => {    
    this.setState({ personality_description : petDescriptionData.personality_description, personality_description_full : petDescriptionData.personality_description_full });
  }

  handlePetZodiacDescriptionResponse = (petZodiacDescriptionData) => {
    this.setState({ pet_zodiac_description: petZodiacDescriptionData });
  }
  
  selectHandler = (e,url) => {
   e.preventDefault();
   this.setState({ newImgSrc : url.src, newZoom : 1, newRotate: 0, selectedImage : url, newSelectedPrimaryImageOption: url.isPrimary  },);

  }
  
  saveHandle = () => {
    let imageNew = "";   
    let selectedArray =[];
    selectedArray = this.state.editedImages;   
    let allImages = this.state.loadedImages;
    if(this.state.newSelectedPrimaryImageOption){
    allImages.map((image)=>{
        image.isPrimary = false
      });
    }
    const selectedImageIndex = allImages.findIndex((item)=> item.id == this.state.selectedImage.id);
    if(selectedImageIndex >= 0){
      if(this.state.newEditor){
        imageNew = this.state.newEditor.getImage().toDataURL(); 
        allImages[selectedImageIndex].src = imageNew;
        allImages[selectedImageIndex].zoom = this.state.newZoom;
        allImages[selectedImageIndex].isPrimary = this.state.newSelectedPrimaryImageOption;
        allImages[selectedImageIndex].isResize = true;
        } 
     
    }
    this.setState({ loadedImages: allImages });
    NotificationManager.success("Image edited successfully");
  }

  resetHandle = ()=>{

    //let selectedArray =[];  
    let allImages = this.state.loadedImages;
    let allDuplicateImages = this.state.duplicateImages;   
    const dupImageIndex = allDuplicateImages.findIndex((item)=> item.id == this.state.selectedImage.id);
    const allImagesIndex = allImages.findIndex((item)=> item.id == this.state.selectedImage.id);
    if(dupImageIndex >= 0 && allImagesIndex >= 0){  
      allImages[allImagesIndex].src = allDuplicateImages[dupImageIndex].src;
      allImages[allImagesIndex].zoom = allDuplicateImages[dupImageIndex].zoom;
      this.setState({ loadedImages: allImages, testURL: allDuplicateImages[dupImageIndex].src });
    } 
  }

  // Image 01
  uploadImage01 = (file) => {
    let allImages = this.state.loadedImages;
    let duplicateImages = this.state.duplicateImages;
    var reader = new FileReader();
    var url = reader.readAsDataURL(file);
    reader.onloadend = function (e) {
      fixOrientation(
        reader.result,
        { image: true },
        function (fixed, image) { 
          this.setState({
            imgSrc01: fixed, 
            imgName01: file.name
          });
          allImages.push({ src : fixed, name : file.name, zoom: this.state.newZoom, id : 1, isPrimary : true, isResize : false} );      
          duplicateImages.push({ src : fixed, name : file.name, zoom: this.state.newZoom, id : 1, isResize : false});  
          this.setState({ loadedImages: allImages, duplicateImages: duplicateImages, });
           
        }.bind(this)
      );
    }.bind(this);
  };

   // Image 02
   uploadImage02 = (file) => {
    let allImages = this.state.loadedImages;
    let duplicateImages = this.state.duplicateImages;   
    var reader = new FileReader();
    var url = reader.readAsDataURL(file);
    reader.onloadend = function (e) {
      fixOrientation(
        reader.result,
        { image: true },
        function (fixed, image) {
          this.setState({
            imgSrc02: fixed,
            imgName02: file.name
          });
          allImages.push({ src : fixed, name : file.name, zoom: this.state.newZoom,  id : 2, isPrimary : false, isResize : false } );
          duplicateImages.push({ src : fixed, name : file.name, zoom: this.state.newZoom, id : 2, isResize : false }); 
          this.setState({loadedImages: allImages,  duplicateImages: duplicateImages, });
  
        }.bind(this)
      );
    }.bind(this);
  };

  // Image 03
  uploadImage03 = (file) => {
    let allImages = this.state.loadedImages;
    let duplicateImages = this.state.duplicateImages;
    var reader = new FileReader();
    var url = reader.readAsDataURL(file);

    reader.onloadend = function (e) {
      fixOrientation(
        reader.result,
        { image: true },
        function (fixed, image) {
          this.setState({
            imgSrc03: fixed,
            imgName03: file.name
          });
          allImages.push({ src : fixed, name : file.name, zoom: this.state.newZoom, id : 3, isPrimary : false,  isResize : false} );
          duplicateImages.push({ src : fixed, name : file.name, zoom: this.state.newZoom, id : 3, isResize : false});
          this.setState({loadedImages: allImages,  duplicateImages: duplicateImages });
 
        }.bind(this)
      );
    }.bind(this);
  };

  // Image 04
  uploadImage04 = (file) => {
    let allImages = this.state.loadedImages;    
    let duplicateImages = this.state.duplicateImages;
    var reader = new FileReader();
    var url = reader.readAsDataURL(file);

    reader.onloadend = function (e) {
      fixOrientation(
        reader.result,
        { image: true },
        function (fixed, image) {
          this.setState({
            imgSrc04: fixed,
            imgName04: file.name
          });
          allImages.push({ src : fixed, name : file.name, zoom: this.state.newZoom, id : 4, isPrimary : false,  isResize : false} );
          duplicateImages.push({ src : fixed, name : file.name, zoom: this.state.newZoom, id : 4,  isResize : false});
          this.setState({loadedImages: allImages, duplicateImages: duplicateImages });
        }.bind(this)
      );
    }.bind(this);
  };

  // Image 05
  uploadImage05 = (file) => {
    let allImages = this.state.loadedImages;
    let duplicateImages = this.state.duplicateImages;
    var reader = new FileReader();
    var url = reader.readAsDataURL(file);

    reader.onloadend = function (e) {
      fixOrientation(
        reader.result,
        { image: true },
        function (fixed, image) {
          this.setState({
            imgSrc05: fixed,
            imgName05: file.name
          });
          allImages.push({ src : fixed, name : file.name, zoom: this.state.newZoom, id : 5, isPrimary : false,  isResize : false} );
          duplicateImages.push({ src : fixed, name : file.name, zoom: this.state.newZoom, id : 5});  
          this.setState({loadedImages: allImages, duplicateImages: duplicateImages });
        }.bind(this)
      );
    }.bind(this);
  };

  // Image 06
  uploadImage06 = (file) => {
      let allImages = this.state.loadedImages;
      let duplicateImages = this.state.duplicateImages;
      var reader = new FileReader();
      var url = reader.readAsDataURL(file);
  
      reader.onloadend = function (e) {
        fixOrientation(
          reader.result,
          { image: true },
          function (fixed, image) {
            this.setState({
              imgSrc06: fixed,
              imgName06: file.name
            });
            allImages.push({ src : fixed, name : file.name, zoom: this.state.newZoom, id : 6, isPrimary : false,  isResize : false} );
            duplicateImages.push({ src : fixed, name : file.name, zoom: this.state.newZoom, id : 6}); 
            this.setState({loadedImages: allImages, duplicateImages: duplicateImages });
          }.bind(this)
        );
      }.bind(this);
  };

  // Image 07
  uploadImage07 = (file) => {
      let allImages = this.state.loadedImages;
      let duplicateImages = this.state.duplicateImages;
      var reader = new FileReader();
      var url = reader.readAsDataURL(file);
  
      reader.onloadend = function (e) {
        fixOrientation(
          reader.result,
          { image: true },
          function (fixed, image) {
            this.setState({
              imgSrc07: fixed,
              imgName07: file.name
            });
            allImages.push({ src : fixed, name : file.name, zoom: this.state.newZoom, id : 7, isPrimary : false, isResize : false} );
            duplicateImages.push({ src : fixed, name : file.name, zoom: this.state.newZoom, id : 7});  
            this.setState({loadedImages: allImages, duplicateImages: duplicateImages });
          }.bind(this)
        );
      }.bind(this);
  };

  // Image 08
  uploadImage08 = (file) => {
      let allImages = this.state.loadedImages;
      let duplicateImages = this.state.duplicateImages;
      var reader = new FileReader();
      var url = reader.readAsDataURL(file);
  
      reader.onloadend = function (e) {
        fixOrientation(
          reader.result,
          { image: true },
          function (fixed, image) {
            this.setState({
              imgSrc08: fixed,
              imgName08: file.name
            });
            allImages.push({ src : fixed, name : file.name, zoom: this.state.newZoom, id : 8, isPrimary : false, isResize : false} );
            duplicateImages.push({ src : fixed, name : file.name, zoom: this.state.newZoom, id : 8});        
            this.setState({loadedImages: allImages, duplicateImages: duplicateImages  });
          }.bind(this)
        );
      }.bind(this);
  }; 

  // Image 09
  uploadImage09 = (file) => {
      let allImages = this.state.loadedImages;
      let duplicateImages = this.state.duplicateImages;
      var reader = new FileReader();
      var url = reader.readAsDataURL(file);
  
      reader.onloadend = function (e) {
        fixOrientation(
          reader.result,
          { image: true },
          function (fixed, image) {
            this.setState({
              imgSrc09: fixed,
              imgName09: file.name
            });
            allImages.push({ src : fixed, name : file.name, zoom: this.state.newZoom, id : 9, isPrimary : false, isResize : false });
            duplicateImages.push({ src : fixed, name : file.name, zoom: this.state.newZoom, id : 9 });        
            this.setState({ loadedImages: allImages, duplicateImages: duplicateImages  });
          }.bind(this)
        );
      }.bind(this);
  }; 

    // Image 10
  uploadImage10 = (file) => {
      let allImages = this.state.loadedImages;
      let duplicateImages = this.state.duplicateImages;
      var reader = new FileReader();
      var url = reader.readAsDataURL(file);
  
      reader.onloadend = function (e) {
        fixOrientation(
          reader.result,
          { image: true },
          function (fixed, image) {
            this.setState({
              imgSrc10: fixed,
              imgName10: file.name
            });
            allImages.push({ src : fixed, name : file.name, zoom: this.state.newZoom, id : 10, isPrimary : false, isResize : false });
            duplicateImages.push({ src : fixed, name : file.name, zoom: this.state.newZoom, id : 10 });        
            this.setState({ loadedImages: allImages, duplicateImages: duplicateImages  });
          }.bind(this)
        );
      }.bind(this);
  }; 

  setNewEditorRef = editor =>{
    if (editor) {
      this.setState({ newEditor: editor });
    }
    
  }

  changeNewZoom = val => {
    if (val) {
      this.setState({ newZoom: val });
    }
  };

  changeNewRotate = () =>{
    var nr = parseInt(this.state.newRotate) + 90;
    if (nr >= 360) nr = 0;
    this.setState({ newRotate: nr });
  }

  // Image 01
  setEditorRef01 = editor => {
    if (editor) {
      this.setState({ editor01: editor });
    }
  };

  // Image 02
  setEditorRef02 = editor => {
    if (editor) {
      this.setState({ editor02: editor });
    }
  };

  // Image 03
  setEditorRef03 = editor => {
    if (editor) {
      this.setState({ editor03: editor });
    }
  };

  // Image 04
  setEditorRef04 = editor => {
    if (editor) {
      this.setState({ editor04: editor });
    }
  };

  // Image 05
  setEditorRef05 = editor => {
    if (editor) {
      this.setState({ editor05: editor });
    }
  };

  // Image 06
  setEditorRef06 = editor => {
    if (editor) {
      this.setState({ editor06: editor });
    }
  };

  // Image 07
  setEditorRef07 = editor => {
    if (editor) {
      this.setState({ editor07: editor });
    }
  };

  // Image 08
  setEditorRef08 = editor => {
    if (editor) {
      this.setState({ editor08: editor });
    }
  };

  // Image 09
  setEditorRef09 = editor => {
    if (editor) {
      this.setState({ editor09: editor });
     }
  };

  // Image 10
  setEditorRef10 = editor => {
    if (editor) {
      this.setState({ editor10: editor });
    }
  };

  // Image 01
  changeZoom01 = val => {
    if (val) {
      this.setState({ zoom01: val });
    }
  };

  changeRotate01 = () => {
    var nr = parseInt(this.state.rotate01) + 90;
    if (nr >= 360) nr = 0;
    this.setState({ rotate01: nr });
  };

  // Image 02
  changeZoom02 = val => {
    if (val) {
      this.setState({ zoom02: val });
    }
  };

  changeRotate02 = () => {
    var nr = parseInt(this.state.rotate02) + 90;
    if (nr >= 360) nr = 0;
    this.setState({ rotate02: nr });
  };

  // Image 03
  changeZoom03 = val => {
    if (val) {
      this.setState({ zoom03: val });
    }
  };

  changeRotate03 = () => {
    var nr = parseInt(this.state.rotate03) + 90;
    if (nr >= 360) nr = 0;
    this.setState({ rotate03: nr });
  };

  // Image 04
  changeZoom04 = val => {
    if (val) {
      this.setState({ zoom04: val });
    }
  };

  changeRotate04 = () => {
    var nr = parseInt(this.state.rotate04) + 90;
    if (nr >= 360) nr = 0;
    this.setState({ rotate04: nr });
  };

  // Image 05
  changeZoom05 = val => {
    if (val) {
      this.setState({ zoom05: val });
    }
  };

  changeRotate05 = () => {
    var nr = parseInt(this.state.rotate05) + 90;
    if (nr >= 360) nr = 0;
    this.setState({ rotate05: nr });
  };

  changePrimaryImageOption = (changedEvent) => {
    if (changedEvent && changedEvent.target && changedEvent.target.value) {
      this.setState({
        selectedPrimaryImageOption: changedEvent.target.value
      });
    }
    else {
      this.setState({
        selectedPrimaryImageOption: '1'
      });
    }
  };

  newChangePrimaryImageOption = (changedEvent) => {
    if (changedEvent && changedEvent.target && changedEvent.target.value) {
      let bool_value = changedEvent.target.value == "true" ? true : false;   
      this.setState({ newSelectedPrimaryImageOption: bool_value });
    }
  };

  cancelChangeAvatar = async (event) => {
    event.preventDefault();
    const medicalRecord = this.state.medicalRecord;
    let images = {
      imgSrc01: "",
      imgName01: "",

      imgSrc02: "",
      imgName02: "",

      imgSrc03: "",
      imgName03: "",

      imgSrc04: "",
      imgName04: "",

      imgSrc05: "",
      imgName05: "",
    };

    if (medicalRecord.avatar_path && medicalRecord.avatar_file_name) {
      const imageURL = `${process.env.REACT_APP_S3_PATH}/${medicalRecord.avatar_path}/${medicalRecord.avatar_file_name}`;
      images.imgSrc01 = await this.getImageDataURL(imageURL);
      images.imgName01 = medicalRecord.avatar_title;
    }

    if (medicalRecord.image02_path && medicalRecord.image02_file_name) {
      const imageURL = `${process.env.REACT_APP_S3_PATH}/${medicalRecord.image02_path}/${medicalRecord.image02_file_name}`;
      images.imgSrc02 = await this.getImageDataURL(imageURL);
      images.imgName02 = medicalRecord.image02_file_name;
    }

    if (medicalRecord.image03_path && medicalRecord.image03_file_name) {
      const imageURL = `${process.env.REACT_APP_S3_PATH}/${medicalRecord.image03_path}/${medicalRecord.image03_file_name}`;
      images.imgSrc03 = await this.getImageDataURL(imageURL);
      images.imgName03 = medicalRecord.image03_file_name;
    }

    if (medicalRecord.image04_path && medicalRecord.image04_file_name) {
      const imageURL = `${process.env.REACT_APP_S3_PATH}/${medicalRecord.image04_path}/${medicalRecord.image04_file_name}`;
      images.imgSrc04 = await this.getImageDataURL(imageURL);
      images.imgName04 = medicalRecord.image04_file_name;
    }

    if (medicalRecord.image05_path && medicalRecord.image05_file_name) {
      const imageURL = `${process.env.REACT_APP_S3_PATH}/${medicalRecord.image05_path}/${medicalRecord.image05_file_name}`;
      images.imgSrc05 = await this.getImageDataURL(imageURL);
      images.imgName05 = medicalRecord.image05_file_name;
    }
    this.setState({
      changeAvatar: false,
      imgSrc01: images.imgSrc01,
      imgName01: images.imgName01,

      imgSrc02: images.imgSrc02,
      imgName02: images.imgName02,

      imgSrc03: images.imgSrc03,
      imgName03: images.imgName03,

      imgSrc04: images.imgSrc04,
      imgName04: images.imgName04,

      imgSrc05: images.imgSrc05,
      imgName05: images.imgName05,
    });
  };

  changeAvatar = () => {
    this.setState({ changeAvatar: true });
  };

  checkAvailableImage = () => {
    let isPetImageAvailable = false;
    const { imgSrc01, imgSrc02, imgSrc03, imgSrc04, imgSrc05 } = this.state;
    const images = [imgSrc01, imgSrc02, imgSrc03, imgSrc04, imgSrc05];

    for (let index = 0; index < images.length; index++) {
      if (images[index]) {
        isPetImageAvailable = true;
        break;
      }
    }

    return isPetImageAvailable;
  };

  saveAvatar = async () => {
   // if (!this.state.imgSrc01) {
    //   NotificationManager.error("Please select image(s) before proceeding with the upload.");
    //   return;
    // }
    $("#image-resize-model").modal("hide");
  //  Image 01 Upload
    var image01 = "";
    if (this.state.editor01 && this.state.imgSrc01) {
      image01 = this.state.editor01.getImage();
      image01 = resizeImage(image01, 1000, 1000);
    }

   // Image 02 Upload
    var image02 = "";
    if (this.state.editor02 && this.state.imgSrc02) {
      image02 = this.state.editor02.getImage();
      image02 = resizeImage(image02, 1000, 1000);
    }

    // Image 03 Upload
    var image03 = "";
    if (this.state.editor03 && this.state.imgSrc03) {
      image03 = this.state.editor03.getImage();
      image03 = resizeImage(image03, 1000, 1000);
    }

    // Image 04 Upload
     var image04 = "";
    if (this.state.editor04 && this.state.imgSrc04) {
      image04 = this.state.editor04.getImage();
      image04 = resizeImage(image04, 1000, 1000);
    }

   // Image 05 Upload
    var image05 = "";
    if (this.state.editor05 && this.state.imgSrc05) {
      image05 = this.state.editor05.getImage();
      image05 = resizeImage(image05, 1000, 1000);
    }

    // Image 06 Upload
    var image06 = "";
    if (this.state.editor06 && this.state.imgSrc06) {
      image06 = this.state.editor06.getImage();
      image06 = resizeImage(image06, 1000, 1000);
    }

    // Image 07 Upload
     var image07 = "";
      if (this.state.editor07 && this.state.imgSrc07) {
        image07 = this.state.editor07.getImage();
        image07 = resizeImage(image07, 1000, 1000);
    }

    // Image 08 Upload
    var image08 = "";
      if (this.state.editor08 && this.state.imgSrc08) {
        image08 = this.state.editor08.getImage();
        image08 = resizeImage(image08, 1000, 1000);
    }

    // Image 09 Upload
    var image09 = "";
    if (this.state.editor09 && this.state.imgSrc09) {
          image09 = this.state.editor09.getImage();
          image09 = resizeImage(image09, 1000, 1000);
    }

    // Image 10 Upload
    var image10 = "";
    if (this.state.editor10 && this.state.imgSrc10) {
        image10 = this.state.editor10.getImage();
        image10 = resizeImage(image10, 1000, 1000);
    }
    
    if(this.state.loadedImages && this.state.loadedImages.length > 0){ 
         var data = {       
          avatar: image01,     
          avatar_title: this.state.loadedImages[0] ? this.state.loadedImages[0].name : "",

          image02: image02 ,     
          image02_title: this.state.loadedImages[1] ? this.state.loadedImages[1].name : "",

          image03: image03 ,     
          image03_title: this.state.loadedImages[2] ? this.state.loadedImages[2].name : "",

          image04: image04 ,     
          image04_title: this.state.loadedImages[3] ? this.state.loadedImages[3].name : "",

          image05: image05 ,     
          image05_title: this.state.loadedImages[4] ? this.state.loadedImages[4].name : "",

          image06: image06,
          image06_title:  this.state.loadedImages[5] ? this.state.loadedImages[5].name : "",

          image07: image07,
          image07_title:  this.state.loadedImages[6] ? this.state.loadedImages[6].name : "",

          image08: image08,
          image08_title:  this.state.loadedImages[7] ? this.state.loadedImages[7].name : "",

          image09: image09,
          image09_title:  this.state.loadedImages[8] ? this.state.loadedImages[8].name : "",

          image10: image10,
          image10_title:  this.state.loadedImages[9] ? this.state.loadedImages[9].name : "",

          woo_pet_id: this.state.mRecord.woo_pet_id
        };
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        await this.setState({updateAvatarData: data, avatarUpdate: true, priceUpdate: false});
        this.proceedUpdate({avatarUpdate: true, priceUpdate: false});
 
    }
    else{
      NotificationManager.error("Please select image(s) before proceeding with the upload.");
      return;
    }
  };

  // changeVideo = () => {
  //   let videoFile = !this.state.changeVideo; 
  //   this.setState({changeVideo: videoFile, loadingVideo : false, videoPlayer: false, videoUploadingFlag: true})
  // } 

  deleteAvatar= ()=> {
    this.setState({deletingImage : true });
    let medicalRecordId = this.state.mRecord.id;  
    let imagePath= "";
    let imageTitle = "";
    let imageName = "";
    $("#confirm_delete_profile_image_modal").modal("hide");
    switch (this.state.selectedDeletableImage.imageNumber) {
        case 1:
          break;
        case 2:   
          imagePath = 'image02_path';
          imageTitle = 'image02_title';
          imageName = 'image02_file_name';        
          break;
        case 3:     
          imagePath = 'image03_path';
          imageTitle = 'image03_title';
          imageName = 'image03_file_name';  
          break;
        case 4:
          imagePath = 'image04_path';
          imageTitle = 'image04_title';
          imageName = 'image04_file_name';  
          break;
        case 5:
          imagePath = 'image05_path';
          imageTitle = 'image05_title';
          imageName = 'image05_file_name'; 
          break;
        case 6:
          imagePath = 'image06_path';
          imageTitle = 'image06_title';
          imageName = 'image06_file_name'; 
          break;
        case 7:
          imagePath = 'image07_path';
          imageTitle = 'image07_title';
          imageName = 'image07_file_name'; 
          break;
        case 8:
          imagePath = 'image08_path';
          imageTitle = 'image08_title';
          imageName = 'image08_file_name'; 
          break;
        case 9:
          imagePath = 'image09_path';
          imageTitle = 'image09_title';
          imageName = 'image09_file_name'; 
          break;
        case 10:
          imagePath = 'image10_path';
          imageTitle = 'image10_title';
          imageName = 'image10_file_name'; 
          break;
        default:
          break;
      }
   let data = {
    path : imagePath,
    title : imageTitle,
    name : imageName, 
   }
    
    this.props.deleteProfileImage(medicalRecordId,data);
  }

  openDeleteConfirmModal= (item)=>{
    let pet =this.state.selectedDeletableImage;
    if(pet.isPrimary !== true){     
      $("#confirm_delete_profile_image_modal").modal("show");
    }
    else{
      NotificationManager.warning("Primary image cannot be deleted");
    }
  }

  changeVideo = () => {
    const maxUploadImages = 9;
    const petImageCount = this.state.mRecord && this.state.mRecord.petImages && this.state.mRecord.petImages.length > 0 ? this.state.mRecord.petImages.length : 0 ;
    if(petImageCount <= maxUploadImages){
      let videoFile = !this.state.changeVideo; 
      this.setState({changeVideo: videoFile, loadingVideo : false, videoPlayer: false, videoUploadingFlag: true});
    }else{ 
      $("#delete_profile_pic").modal("show");
    }
  } 

  removeVideo = (event, video_id, m_record_id) => {
    event.preventDefault();
    if (video_id && m_record_id) {
      $("#confirm_delete_video_modal").modal("show");
    }
  }

  confirmAndDeleteVideo = (event) => {
    event.preventDefault();
    const { mRecord, updatedVideoId } = this.state;
    if (mRecord && mRecord.id && updatedVideoId) {
      const data = {
        video_id: updatedVideoId,
        medical_record_id: mRecord.id,
      };

      this.props.removePuppyVideo(data);
      this.setState({ loadingDeleteVideo: true });
    }
  }

  selectUploader = () => {
    let uploader = this.state.videoHoster;   
    switch(uploader){
      case "wistia":
       this.uploadVideoViaWistia();
       break;
      case "vimeo":  
       this.uploadVideoViaVimeo();
       break; 
      default:
       break;
    }
  }
 
  uploadVideoViaWistia = async (e) => { 
   let videoFile = this.state.selectedVideoFile;    
   if(videoFile){    
     this.setState({loadingVideo : true, changeVideo: false, videoPlayer: false});
     let medicalRecordObj = this.state.mRecord;
     let medicalRecordId = medicalRecordObj.id;   
     let uploadFileData = new FormData();
     let videoName = medicalRecordObj.pet_id && medicalRecordObj.Breed.breed_type ? `${medicalRecordObj.pet_id}-${medicalRecordObj.Breed.breed_type}` : videoFile.name;
     uploadFileData.append('file', videoFile);
     uploadFileData.append('name', videoName );
     uploadFileData.append('project_id',config.videoUploader.wistia.project_id);
     uploadFileData.append('access_token',config.videoUploader.wistia.access_token);     
     try {
        const options = {
          onUploadProgress: (progressEvent) => {
            const {loaded, total} = progressEvent;
            let percent = Math.floor( (loaded * 100) / total );       
      
            if( percent <= 70 ){          
              this.setState({ uploadPercentage: percent })
            }
            else if(90 < percent <= 100){        
              this.setState({ uploadPercentage: 60 })
            }
          }
        } 
        let uploadedVideo = await axios.post("https://upload.wistia.com", uploadFileData, options);      
       if(uploadedVideo && uploadedVideo.data){   
           medicalRecordObj.video_url = uploadedVideo.data.hashed_id;
           medicalRecordObj.video_id = uploadedVideo.data.hashed_id;
           medicalRecordObj.video_name = uploadedVideo.data.name;
           medicalRecordObj.video_source = "wistia";
           medicalRecordObj.availablePetId = true; 
           this.setState({ uploadPercentage: 100, updatedVideoUrl: uploadedVideo.data.hashed_id});
          this.props.updateMedicalRecord(medicalRecordId, medicalRecordObj);      
          if(this.state.updatedVideoId){
            await this.deletePreviousVideo(this.state.updatedVideoId);
          }
        }
       } catch (error) {       
         NotificationManager.error("An error occured while uploading the video")
         this.setState({ loadingVideo : false });
       }
   }
   else{
     NotificationManager.warning("Please select a video before proceeding with the upload.");
   }
 
  } 

  uploadVideoViaVimeo = async (e) => { 
    let videoFile = this.state.selectedVideoFile;    
    if(videoFile){
      let size = videoFile.size;
      this.setState({loadingVideo : true, changeVideo: false, videoPlayer: false});
      let medicalRecordObj = this.state.mRecord;
      let medicalRecordId = medicalRecordObj.id;    
      let binaryVideoFile = await this.videoToBinary(videoFile);
      let videoName =  medicalRecordObj.pet_id && medicalRecordObj.Breed.breed_type ? `(${medicalRecordObj.pet_id}) ${medicalRecordObj.Breed.breed_type}` : `PUPPY VIDEO - ${Math.random().toString().substr(2, 6)}`;
      try {
        if(this.state.updatedVideoId){            
          await this.deletePreviousVideo(this.state.updatedVideoId); 
        }

         let uploadedDummyVideo = await axios.post("https://api.vimeo.com/me/videos",      
        {       
          "upload" : {
            "approach": "tus",
            "size": size,              
          },
          "name" : videoName,
          "embed": {
            "end_screen": {
              "type": "empty"
            }
          },
        },{    
          headers: {
             Authorization: "Bearer "+config.videoUploader.vimeo.access_token,   
              'Content-Type' : "application/json",
              Accept : "application/vnd.vimeo.*+json;version=3.4" ,                  
          }   
                 
        });       
          if(uploadedDummyVideo && uploadedDummyVideo.data){           
            let tempUrl = uploadedDummyVideo.data.upload.upload_link ? uploadedDummyVideo.data.upload.upload_link : null;    
            if(tempUrl){
              let uploadedVideo = await axios.patch(tempUrl,      
              binaryVideoFile,         
              {    
                headers: {
                'Tus-Resumable': '1.0.0',
                'Upload-Offset': 0,
                'Content-Type': 'application/offset+octet-stream',
                'Accept': 'application/vnd.vimeo.*+json;version=3.4'             
               }   
                          
              },            
              );            
              if(uploadedVideo && uploadedVideo.headers['upload-offset'] == size ){         
                this.setState({ updatedVideoUrl: uploadedDummyVideo.data.player_embed_url });
                medicalRecordObj.video_name = uploadedDummyVideo.data.name;
                medicalRecordObj.video_url = uploadedDummyVideo.data.player_embed_url;
                medicalRecordObj.video_id = uploadedDummyVideo.data.uri;
                medicalRecordObj.video_source = "vimeo";
                medicalRecordObj.availablePetId = true; 
                this.props.updateMedicalRecord(medicalRecordId, medicalRecordObj);   
                }else{
                 this.setState({ loadingVideo : false });
                 NotificationManager.warning("There was an error in the upload process. Please try again");
                }
            } 
            else{
             this.setState({ loadingVideo : false });
             NotificationManager.warning("There was an error in the upload process. Please try again");
            }           
          }    
        } catch (error) {
          if(error && error.response && error.response.data && error.response.data.error_code == 4101){              
            NotificationManager.warning("Allocated video quota has been reached.");
          }else if(error && error.response && error.response.data && error.response.data.error_code == 4102){         
            NotificationManager.warning("Weekly video quota has been reached.");
          }else if(error && error.response && error.response.data && error.response.data.error_code == 4104){      
            NotificationManager.warning("Daily video quota has been reached.");
          }else{      
            NotificationManager.warning("An error occured while uploading the video. Please try again later.");
          } 
          this.setState({ loadingVideo : false });
        }
    }
    else{
      NotificationManager.warning("Please select a video before proceeding with the upload.");
    }
  
  }

  videoToBinary =async (videoFile) =>{
    return new Promise((resolve,reject)=>{
      const reader = new FileReader();    
      reader.onload = function () {
        const result = reader.result;      
        return resolve(result);
      };  
      reader.onerror = function (error) {
        return reject(error);
      };    
      reader.readAsArrayBuffer(videoFile);
    });
    
  }

  deletePreviousVideo = async(videoId) =>{
    if(videoId){
      if(this.state.currentVideoSource == videoHoster.wistia){
          try{
          let dd = await axios.delete(`https://api.wistia.com/v1/medias/${videoId}.json`,{
            headers: {
                Authorization: "Bearer"+" "+config.videoUploader.wistia.access_token         
              }});    

            }catch(err){           
              NotificationManager.error("A problem occured while deleting the previous video");     
            }       
      }else if(this.state.currentVideoSource == videoHoster.vimeo ){
          try {
            let deletedVideo = await axios.delete(`https://api.vimeo.com${videoId}`,
            {    
              headers: {
                Authorization: "Bearer "+config.videoUploader.vimeo.access_token,   
                  'Content-Type' : "application/json",
                  Accept : "application/vnd.vimeo.*+json;version=3.4" ,                  
              }   
            }
            );        
            
          } catch (error) {          
            NotificationManager.error("A problem occured while deleting the previous video");  
          }
      }
    }
    else{
      NotificationManager.error("Previoulsy uploaded video not found");
    }
  }

  disableVimeoPlayer = (error)=>{
    this.setState({ vimeoLoaded: false });    
  }


  onChangeVideoHandler = (event) => {
    var files = this.refs.videoFile && this.refs.videoFile.files &&  this.refs.videoFile.files.length > 0 ? this.refs.videoFile.files[0] : null;  
    this.setState({
        selectedVideoFile: files,      
    });
  };

  changeDate = value => {
    this.setState({ 
      arrival_date: moment(value, "MM-DD-YYYY"), 
      arrival_date_picker: moment(value, "MM-DD-YYYY").toDate() 
    });
  };


  setArrivalDateOnDOBChange = dob => {
    dob = moment(dob);
    let today = moment();
    let dateOfBirth = this.changeDateFormat(dob, "MM-DD-YYYY", "YYYY-MM-DD");
    today = this.changeDateFormat(today, "MM-DD-YYYY", "YYYY-MM-DD");
    const petAgeInWeeks = moment(today).diff(moment(dateOfBirth) , 'week');
    if(petAgeInWeeks < 8){
        const afterEightWeeksFromDOB = moment(dob).add(8, 'weeks');
        const checkDate = afterEightWeeksFromDOB.isoWeekday();
          switch(checkDate){
            case 1:
              this.setState({
                arrival_date :moment(afterEightWeeksFromDOB).add(1, 'days').format("MM-DD-YYYY"), 
                arrival_date_picker: moment(afterEightWeeksFromDOB).add(1, 'days').toDate()
              });
              break;
            case 2:
              this.setState({
                arrival_date:moment(afterEightWeeksFromDOB).add(7, 'days').format("MM-DD-YYYY"),
                arrival_date_picker: moment(afterEightWeeksFromDOB).add(7, 'days').toDate()
              });
              break;
            case 3:  
              this.setState({
                arrival_date :moment(afterEightWeeksFromDOB).add(6, 'days').format("MM-DD-YYYY"),
                arrival_date_picker: moment(afterEightWeeksFromDOB).add(6, 'days').toDate()
              });
              break;
            case 4:
              this.setState({
                arrival_date :moment(afterEightWeeksFromDOB).add(5, 'days').format("MM-DD-YYYY"),
                arrival_date_picker: moment(afterEightWeeksFromDOB).add(5, 'days').toDate()
              });
              break;
            case 5:
              this.setState({
                arrival_date :moment(afterEightWeeksFromDOB).add(4, 'days').format("MM-DD-YYYY"),
                arrival_date_picker :moment(afterEightWeeksFromDOB).add(4, 'days').toDate()
              });
              break;
            case 6:
              this.setState({
                arrival_date :moment(afterEightWeeksFromDOB).add(3, 'days').format("MM-DD-YYYY"),
                arrival_date_picker: moment(afterEightWeeksFromDOB).add(3, 'days').toDate()
              });
              break;
            case 7:
              this.setState({
                arrival_date :moment(afterEightWeeksFromDOB).add(2, 'days').format("MM-DD-YYYY"),
                arrival_date_picker: moment(afterEightWeeksFromDOB).add(2, 'days').toDate()
              });
              break;  
            default:
              break;  
          }   
    }else{
      const checkDate = today.isoWeekday();
      switch(checkDate){
        case 1:
          this.setState({
            arrival_date :moment(today).add(1, 'days').format("MM-DD-YYYY"),
            arrival_date_picker: moment(today).add(1, 'days').toDate()
          });
          break;
        case 2:
          this.setState({
            arrival_date:moment(today).add(7, 'days').format("MM-DD-YYYY"),
            arrival_date_picker: moment(today).add(7, 'days').toDate()
          });
          break;
        case 3:  
          this.setState({
            arrival_date :moment(today).add(6, 'days').format("MM-DD-YYYY"),
            arrival_date_picker: moment(today).add(6, 'days').toDate()
          });
          break;
        case 4:
          this.setState({
            arrival_date :moment(today).add(5, 'days').format("MM-DD-YYYY"),
            arrival_date_picker: moment(today).add(5, 'days').toDate()
          });
          break;
        case 5:
          this.setState({
            arrival_date :moment(today).add(4, 'days').format("MM-DD-YYYY"),
            arrival_date_picker: moment(today).add(4, 'days').toDate()
          });
          break;
        case 6:
          this.setState({
            arrival_date :moment(today).add(3, 'days').format("MM-DD-YYYY"),
            arrival_date_picker: moment(today).add(3, 'days').toDate()
          });
          break;
        case 7:
          this.setState({
            arrival_date :moment(today).add(2, 'days').format("MM-DD-YYYY"),
            arrival_date_picker: moment(today).add(2, 'days').toDate()
          });
          break;  
        default:
          break;  
      }
    }
  }

  changeDob = value => {
    this.setState({ 
      date_of_birth: moment(value, "MM-DD-YYYY"), 
      dob_picker: moment(value, "MM-DD-YYYY").toDate() 
    });
    this.setArrivalDateOnDOBChange(value);
  };

  changeSelectionVal = event => {
    let value = event.target.value;

    this.setState({
      ...this.state,
      [event.target.name]: value
    });
  }

  changeVal = event => {
    let excludes = ["weight", "price", "adult_weight","pet_name","personality_description"];
    if (!excludes.includes(event.target.name)) forceInputUppercase(event);

    this.setState({ [event.target.name]: event.target.value });
  };

  incrementPrice = (event) => {
    event.preventDefault();
    let price = parseFloat(this.state.price);
    price += 50;
    this.setState({ price: price.toFixed(2) })
  }

  decrementPrice = (event) => {
    event.preventDefault();
    let price = parseFloat(this.state.price);
    price -= 50;
    this.setState({ price: price.toFixed(2) })
  }

  changePrice = event => {
    this.setState({ price: event.target.value });
  };

  changeToa = selected => {
    if (selected) {
      this.setState({ PetId: selected.value, petType : selected.label });
    }
  };

  changeBreed = selected => {
    if (selected) {
      this.setState({ BreedId: selected.value, petBreedName : selected.label });
      this.props.fetchBreedInfo(selected.value);
    }
  };

  changeRegType = selected => {
    if (selected) {
      this.setState({ RegistrationTypeId: selected.value });
      if(selected.label=="NOT APPLICABLE"){
        this.setState({ dam_number:'NOT APPLICABLE', sire_number:'NOT APPLICABLE', siredam_disable: true });
      }
      else{
        this.setState({ dam_number:'PENDING', sire_number:'PENDING', siredam_disable: false });
      }
    }
  };

  changeBreeder = selected => {
    if (selected) {
      this.setState({ BreederId: selected.value });
    }
  };
  changeBreedCategory = selected => {
    if (selected) {
      this.setState({ BreedCategoryId: selected.value });
    }
  };
  toggleBreeder = () => {
    if (this.state.new_breeder) this.setState({ new_breeder: false });
    else this.setState({ new_breeder: true });
  };
  editNote = () => {
    if (!this.state.editNote) {
      this.setState({
        editNote: true,
        notes: this.state.mRecord.notes ? this.state.mRecord.notes : ""
      });
    } else {
      this.cancelEditNote();
    }
  };

  skipArrivalDateValidation = status => {
    this.setState({validateArrivalDate : status});
  }

  editInfo = () => {
    if (!this.state.editInfo) {
      
      this.setState({
        editInfo: true,
        avatarUpdate: false,
        priceUpdate: false,
        arrival_date: moment(this.state.mRecord.arrival_date, "MM-DD-YYYY"),
        arrival_date_picker: moment(
          this.state.mRecord.arrival_date
            ? moment(this.state.mRecord.arrival_date,"MM-DD-YYYY")
            : now()
        ).toDate(),
        color_markings: this.state.mRecord.color_markings
          ? this.state.mRecord.color_markings
          : "",
        micro_chip: this.state.mRecord.micro_chip
          ? this.state.mRecord.micro_chip
          : "",
        sire: this.state.mRecord.sire ? this.state.mRecord.sire : "",
        dam: this.state.mRecord.dam ? this.state.mRecord.dam : "",
        sire_number: this.state.mRecord.sire_number
          ? this.state.mRecord.sire_number
          : "",
        dam_number: this.state.mRecord.dam_number
          ? this.state.mRecord.dam_number
          : "",
        pet_id: this.state.mRecord.pet_id ? this.state.mRecord.pet_id : "",
        date_of_birth: moment(this.state.mRecord.date_of_birth, "MM-DD-YYYY"),
        dob_picker: moment(
          this.state.mRecord.date_of_birth
            ? moment(this.state.mRecord.date_of_birth,"MM-DD-YYYY")
            : now()
        ).toDate(),
        sex: this.state.mRecord.sex ? this.state.mRecord.sex : "",
        weight: this.state.mRecord.weight ? this.state.mRecord.weight : "",
        adult_weight: this.state.mRecord.adult_weight ? this.state.mRecord.adult_weight : "",
        cross_breed: this.state.mRecord.cross_breed
          ? this.state.mRecord.cross_breed
          : "",
        price: this.state.mRecord.price ? this.state.mRecord.price : "",
        pet_name: this.state.mRecord.pet_name
        ? this.state.mRecord.pet_name
        : "",
        personality_description: this.state.mRecord.personality_description 
        ?  this.state.mRecord.personality_description
        :"",
        pet_zodiac: this.state.mRecord.pet_zodiac ? this.state.mRecord.pet_zodiac : "",
        pet_zodiac_description: this.state.mRecord.pet_zodiac_description ? this.state.mRecord.pet_zodiac_description : "",
      });
      this.state.toa.map(t => {
        if (t.label === this.state.mRecord.Pet.type) {
          this.setState({ PetId: t.value });
        }
      });

      this.state.breeds.map(t => {
        if (t.label === this.state.mRecord.Breed.breed_type) {      
          this.setState({ BreedId: t.value, petBreedName: t.label });
        }
      });
      this.state.reg_types.map(t => {
        if (t.label === this.state.mRecord.reg_type) {
          this.setState({ RegistrationTypeId: t.value });
        }
      }); 
      this.state.breeds_category.map(t => {
        if(this.state.mRecord && this.state.mRecord.BreedCategory && t.label) {     
        if (t.label == this.state.mRecord.BreedCategory.name) {       
          this.setState({ BreedCategoryId: t.value });
        }
      }
      });

      this.state.foodTypes.map(t => {
        if(this.state.mRecord && this.state.mRecord.FoodType && t.label) {     
        if (t.label == this.state.mRecord.FoodType.title) {       
          this.setState({ FoodTypeId: t.value });
        }
      }
    });
   

    } else {
      this.cancelEditInfo();
    }
  };
  newMedication = (e, type) => {
    e.preventDefault();
    this.setState({ mediModalType: type });
    $("#add_medication").modal("show");
  };
  editBreeder = () => {
    if (!this.state.editBreeder) {
      this.setState({
        editBreeder: true
      });
      this.state.breeders.map(t => {
        if (
          this.state.mRecord.Breeder &&
          t.label === this.state.mRecord.Breeder.breeder
        ) {
          this.setState({ BreederId: t.value });
        } else {
          this.setState({ BreederId: "N/A" });
        }
      });
    } else {
      this.cancelEditBreeder();
    }
  };

  fetchContract = () => {
    if (this.state.mRecord.pet_id) {
      let data = { petId: this.state.mRecord.pet_id };
      this.props.fetchContractFromWooStore(data);
    }
  };

  cancelEditInfo = () => {
    this.setState({ editInfo: false });
  };

  cancelEditBreeder = () => {
    this.setState({ editBreeder: false });
  };

  cancelEditNote = () => {
    this.setState({ editNote: false });
  };

  openConfirmModal = mediId => {
    this.setState({ deleteMediId: mediId });
    $("#confirm_delete_modal").modal("show");
  };

  deleteMedication() {
    this.setState({ loadingDelete: true });
    let data = { id: this.state.deleteMediId };

    if (data) this.props.deleteMedication(data);
    else {
      NotificationManager.warning("Vaccination data can not be found.");
      this.setState({ loadingDelete: false });
    }
  }

  saveBreeder = () => {
    if (!this.state.new_breeder) {
      if (this.state.BreederId === "N/A") {
        NotificationManager.warning("Select or add breeder first.");
      } else {
        this.setState({ loadingBreeder: true });
        let data = {
          BreederId: this.state.BreederId,
          availablePetId: true
     
        };
        if (data.BreederId) {
          this.props.updateMedicalRecord(this.state.mRecord.id, data);
        }
      }
    } else {
      breeder_form = {
        breeder:
          this.state.new_b_name.toString().trim().length > 0
            ? this.state.new_b_name
            : null,
        usda_no:
          this.state.new_b_usda.toString().trim().length > 0
            ? this.state.new_b_usda
            : null,
        address_line_1:
          this.state.new_b_address_line_1.toString().trim().length > 0
            ? this.state.new_b_address_line_1
            : null,
        address_line_2:
          this.state.new_b_address_line_2.toString().trim().length > 0
            ? this.state.new_b_address_line_2
            : "",
        address_city:
          this.state.new_b_address_city.toString().trim().length > 0
            ? this.state.new_b_address_city
            : null,
        address_state:
          this.state.new_b_address_state.toString().trim().length > 0
            ? this.state.new_b_address_state
            : null,
        address_country:
          this.state.new_b_address_country.toString().trim().length > 0
            ? this.state.new_b_address_country
            : null,
        address_postal_code:
          this.state.new_b_address_postal_code.toString().trim().length > 0
            ? this.state.new_b_address_postal_code
            : null,
        phone:
          this.state.new_b_phone.toString().trim().length > 0
            ? this.state.new_b_phone
            : null
      };
      let formdata = Object.values(breeder_form).map(key => {
        if (key === null) {
          return false;
        } else {
          return true;
        }
      });
      if (!formdata.includes(false)) {
        let data = {
          ...breeder_form,
          newBreeder: this.state.new_breeder
        };
        this.props.updateMedicalRecord(this.state.mRecord.id, data);
      } else {
        NotificationManager.warning("Check breeder details again.");
        this.setState({ loadingBreeder: false, currentFormNotValid: true });
      }
    }
  };

  saveNote = () => {
    var edit_note = {
      notes:
        this.state.notes.toString().trim().length > 0 ? this.state.notes : null,
      availablePetId: true
    };
    this.setState({ loadingNote: true });
    this.props.updateMedicalRecord(this.state.mRecord.id, edit_note);
  };

  dateOfBirthRangeIsValid(dob) {
    return(
      moment(dob).diff(moment()) < 0
    )
  }

  arrivalDateIsValid(arrivalDate) {
    const PetArrivalDateInWeeks = config.petArrivalDateInWeeksFromDOB ? config.petArrivalDateInWeeksFromDOB : 8;
    arrivalDate = this.changeDateFormat(arrivalDate, "MM-DD-YYYY", "YYYY-MM-DD");
    let dateOfBirth = this.changeDateFormat(this.state.date_of_birth, "MM-DD-YYYY", "YYYY-MM-DD");
    return (
      moment(arrivalDate).diff(moment(dateOfBirth) , 'week') >= PetArrivalDateInWeeks 
    );
} 

  saveInfo = () => {
    let arrivalDate = this.changeDateFormat(this.state.arrival_date, "MM-DD-YYYY", "YYYY-MM-DD");
    let dateOfBirth = this.changeDateFormat(this.state.date_of_birth, "MM-DD-YYYY", "YYYY-MM-DD");

    edit_form = {
      top:
        this.state.PetId.toString().trim().length > 0 ? this.state.PetId : null,
      arrival: moment(arrivalDate).isValid()
        ? moment(arrivalDate).format("YYYY-MM-DD")
        : null,
      sex: this.state.sex.trim().length > 0 ? this.state.sex : null,
      adult_weight: this.state.adult_weight.trim().length > 0 ? this.state.adult_weight : null,
      pet_id:
        this.state.pet_id.toString().trim().length > 0
          ? this.state.pet_id
          : null,
      breed:
        this.state.BreedId.toString().trim().length > 0
          ? this.state.BreedId
          : null,
      color_markings:
        this.state.color_markings.trim().length > 0
          ? this.state.color_markings
          : null,
      dob: moment(dateOfBirth).isValid()
        ? moment(dateOfBirth).format("YYYY-MM-DD")
        : null,
      dob_range: this.dateOfBirthRangeIsValid(this.state.date_of_birth)
        ? ""
        : null,
      arrival_date_range: this.arrivalDateIsValid(this.state.arrival_date)
        ? ""
        : "invalidArrivalDate",  
      micro_chip:
        this.state.micro_chip.trim().length > 0 ? this.state.micro_chip : null,
      cross_breed:
        this.state.cross_breed.trim().length > 0
          ? this.state.cross_breed
          : null,
      regType:
        this.state.RegistrationTypeId === "N/A"
          ? null
          : this.state.RegistrationTypeId,
      sire:
        this.state.sire.toString().trim().length > 0 ? this.state.sire : null,
      sire_number:
        this.state.sire_number.toString().trim().length > 0
          ? this.state.sire_number
          : null,
      dam: this.state.dam.toString().trim().length > 0 ? this.state.dam : null,
      dam_number:
        this.state.dam_number.toString().trim().length > 0
          ? this.state.dam_number
          : null,
      price:
        this.state.price.toString().trim().length > 0
          ? this.state.price
          : null,
      BreedCategoryId:
        this.state.BreedCategoryId === "N/A"
          ? null
          : this.state.BreedCategoryId, 
     
    };

    if (this.state.personality_description) {
      if (this.state.personality_description.trim().length <= 2000) {
        edit_form.personality_description = this.state.personality_description;
      }
      else {
        edit_form.personality_description = "InvalidDescription";
      }
    }

    this.validateForm(edit_form);
  };
  validateForm = async edit_form => {
    let data = {
      ...this.state
    };

    let formdata = Object.entries(edit_form).map(([key, value]) => {
      if (key !== 'weight' && value === null) {
        return false;
      } else if(key == 'BreedCategoryId' && value === "none"){
        return false;
      }   
      else if(key == "arrival_date_range" && value == "invalidArrivalDate"){
        if(!this.state.validateArrivalDate){
          return true;
        }else{
          return false;
        }       
      }
      else {
        return true;
      }  
    });

    if (!formdata.includes(false)) {
      if (data.pet_id) {
        if (!data.weight) data.weight = null;
        delete data.editor01;
        delete data.imgName01;
        delete data.imgSrc01;
        // data = Object.assign(data, { mc_status: "complete" });

        await this.setState({updateData: data});

        if(this.state.mRecord.price > this.state.price){
          this.setState({priceUpdate: true, avatarUpdate: false});
          this.proceedUpdate({priceUpdate: true, avatarUpdate: false});
        }else{
          this.setState({priceUpdate: false, avatarUpdate: false});
          this.proceedUpdate({priceUpdate: false, avatarUpdate: false});
        }
      }
    } else {
      if(this.state.BreedCategoryId){
        NotificationManager.warning("Please check input details again.");
        this.setState({ currentFormNotValid: true, loadingInfo: false });
      }
      else{
        NotificationManager.warning("Please assign email template to selected breed.");
        this.setState({ currentFormNotValid: true, loadingInfo: false });
      }
      
    }
  };

  items = [
    { title: "Puppy Records", to: "/medical-records" },
    { title: "Edit", to: "/medical-records/" + this.props.match.params.id }
  ];


  prev(path) {   
    let data = this.state.contentData;
    let prevId = Number(this.props.match.params.prev)
    if (this.props.match.params.prev != this.props.match.params.id) {
      if ( prevId !== 0) {
        let index = _.findIndex(data, { id: Number(this.props.match.params.prev) });
        let nextindex = index + 1;   
        let prevEle = nextindex != null ? data[nextindex] ? data[nextindex].id :0: 0;       
        path = path + "/" + prevEle + "/" + this.props.match.params.id;      
        return this.props.history.push(path)
      }
    }

  }

  next(path) {
    let data = this.state.contentData;
    let nextId = Number(this.props.match.params.next);
    if (this.props.match.params.next != this.props.match.params.id) {
      if (nextId !== -1) {
        let index = _.findIndex(data, { id: Number(this.props.match.params.next) });
        let previndex = (index == 0) ? 0 : (index - 1);
        let nextindex = index + 1;       
        let prevEle = nextindex != null ? data[previndex] ? data[previndex].id : -1 : -1;      
        path = path + "/" + this.props.match.params.id + "/" + prevEle;        
        return this.props.history.push(path)
      }
    }

  }

  checkPet = event => {
    forceInputUppercase(event);
    this.loadflag = false;
    let value = event.target.value;
    if (event.target.name === 'pet_id' && value.length > 6) {  
      this.loadflag = true;      
      value = value.split(" ").join("");
      let petobj = {
        pet_id: event.target.value,
        mrId: this.props.match.params.id
      }     
      this.props.findPetById(petobj);
    }
    this.setState({
      ...this.state,
      [event.target.name]: value 
    });
  };  

  handlerBreedData = () => {
    this.setState({
      selectedBreedData : {}  
    });
  }

  goToSelectedBreedSettings = (e) => {
    e.preventDefault();
    this.setState({ selectedBreedData: null }, () => {
      let selectedBreedData = _.find(this.props.breeds, { 'id': this.state.BreedId });
      if (selectedBreedData) {
          this.setState({ selectedBreedData: selectedBreedData});
      }
    })
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      customFormNotValid: false
    });
  }

  setImagePreview = () => {   
    let selectedImages = this.state.loadedImages;
    if(selectedImages && selectedImages.length > 0){
    const primaryImageIndex = selectedImages.findIndex(img => img.isPrimary === true );  
    selectedImages.push(...selectedImages.splice(0, primaryImageIndex));
    this.setState({ loadedImages : selectedImages}); 
    $("#image-resize-model").modal("show");
    }else{
      NotificationManager.error("Please select image(s) before proceeding with the upload.");
    }
  }

  proceedUpdate(opt){
    this.setState({soldReason: null});

    if(this.state.availableSubscribers.length > 0 && this.state.mRecord.Contract === null){
      if(opt.priceUpdate === true){
        $("#send_notification_model").modal("show");
      }else if(opt.avatarUpdate === true){
        $("#send_notification_model").modal("show");
      }else{
        this.completeUpdateMedicalRecord(false);
      }
    }else{
      if(opt.avatarUpdate === true){
        this.completeUpdateAvatar(false);
      }else{
        this.completeUpdateMedicalRecord(false);
      }
    }
  }

  completeUpdateMedicalRecord(notify){
    let data = this.state.updateData;
    if(data){
      this.setState({ loadingInfo: true, loadingMultipleImages: false });
      data["notifySubscribers"] = notify;
      data["arrival_date"] = this.changeDateFormat(data["arrival_date"], "MM-DD-YYYY", "YYYY-MM-DD");
      data["date_of_birth"] = this.changeDateFormat(data["date_of_birth"], "MM-DD-YYYY", "YYYY-MM-DD");
      this.props.updateMedicalRecord(this.state.mRecord.id, data);
      $("#send_notification_model").modal("hide");
    }
    
  }

  completeUpdateAvatar(notify){
    let data = this.state.updateAvatarData;
    if(data){
      this.setState({ loadingInfo: false, loadingMultipleImages: true });
      data["notifySubscribers"] = notify;
      this.props.attachAvatar(this.props.match.params.id, data);
      $("#send_notification_model").modal("hide");
    }
  }

  changeStateOfSoldPopUp(){
    if(this.state.selectedWooPagePuppyStatusOption === this.wooPagePuppyStatusOptions.Sold && !this.state.soldReason || this.state.soldReason === "Select Reason"){
      this.setState({customFormNotValid: true});
      return false;
    }

    this.setState({priceUpdate: false, avatarUpdate: false});
    $("#woo_page_status_modal").modal("hide");
    $("#send_notification_model").modal("show");
  }

  cancelProcess(){
    this.setState({ loadingInfo: false, loadingMultipleImages: false });
  }

  render() {
    const {
      new_breeder,
      new_b_address_line_1,
      new_b_address_line_2,
      new_b_address_city,
      new_b_address_state,
      new_b_address_country,
      new_b_address_postal_code,
      new_b_name,
      new_b_phone,
      new_b_usda,
      mRecord,
      breeders,
      BreederId,
      b_usda,
      b_phone,
      b_address_line_1,
      b_address_line_2,
      b_address_city,
      b_address_state,
      b_address_country,
      b_address_postal_code,
      editBreeder,
      editInfo,
      arrival_date,
      color_markings,
      micro_chip,
      sire,
      sire_number,
      dam,
      dam_number,
      pet_id,
      PetId,
      toa,
      BreedId,
      breeds,
      date_of_birth,
      reg_types,
      RegistrationTypeId,
      sex,
      cross_breed,
      weight,
      adult_weight,
      mediModalType,
      notes,
      editNote,
      price,
      BreedCategoryId,
      FoodTypeId,
      breeds_category,
      foodTypes ,
      foodTypeImagePath,
      foodTypeImageName,
      loading,
      pet_name,
      personality_description,
      pet_zodiac,
      pet_zodiac_description,
      arrival_date_picker,
      dob_picker,
      soldReason,
      loadingPinToTop,
      isPinToTop,
    } = this.state;
    return (
      <div
        className="m-grid m-grid--hor m-grid--root m-page"
        style={{ minHeight: "100vh" }}
      >
        {!loading ? 
        <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body body-background">
          <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver	m-container m-container--responsive m-container--xxl m-page__container">
            <div className="m-grid__item m-grid__item--fluid m-wrapper">
              <div className="row">
                <div className="col-lg-12">
                  <BreadCrumb items={this.items} />
                </div>
                {/* <div className="col-lg-4">
                    <button type="button" className="btn m-btn--pill btn-warning pull-right" style={{marginRight:'25px'}} onClick={() => this.childDownload()}><span style={{fontWeight:400,fontSize:'13px'}}><i className="far fa-file-pdf"></i> Download PDF</span> </button>                    
                </div> */}
              </div>
              <div className="row">
                <div className="col-xs-12 col-sm-8 col-md-8 col-lg-7">
                  <div className="m-portlet m-portlet--full-height">
                    <div
                      className="m-portlet m-portlet--success m-portlet--head-solid-bg"
                      style={{ boxShadow: "none" }}
                    >
                      <div className="m-portlet__head">
                        <div className="m-portlet__head-caption">
                          <div className="m-portlet__head-title">
                            <h3 className="m-portlet__head-text">
                              Pet Information 
                            </h3>
                          </div>
                        </div>
                        <div className="m-portlet__head-tools">
                          {mRecord.mc_status === 'complete' && !mRecord.Contract ?
                            <button
                              onClick={() => this.openConfirmStoreModal()}
                              className="m-portlet__nav-link btn btn-light m-btn m-btn--pill m-btn--air mr-2"
                              disabled={mRecord.woo_pet ? "disabled" : false}
                            >
                              <i className="la la-shopping-cart"></i>
                              <span>{!mRecord.woo_pet ? "Add to Store" : "In Store"}</span>
                            </button>
                            : ""
                          }
                     {  this.state.pdfOldVersion == true ?
                        <span className="dropdown show">
                          <span className="dropdown">
                            <a
                              href=""                      
                              data-toggle="dropdown"
                              aria-expanded="true"
                            >
                            <button                           
                            className="m-portlet__nav-link btn btn-light m-btn m-btn--pill m-btn--air mr-2"
                          >
                            <i className="la la-print"></i>
                            <span>PDF</span>
                          </button>                             
                            </a>
                            <div className="dropdown-menu dropdown-menu-right">   
                              <a 
                                href={ `${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/pdf/${this.props.stateData.petShopReducer.currentPetshop.id}/${mRecord.id}`}              
                                className="dropdown-item"
                                target="_blank"        
                              >
                                <i className="fa fa-print"></i>PDF
                              </a>
                                        
                             <a
                                className="dropdown-item"
                                href="#"
                                onClick={() => {
                                  this.openPdf()
                                }}
                              >
                                <i class="fa fa-print"></i>PDF (Old)
                              </a>
                            
                            </div>
                          </span>
                          </span>:
                            <button                           
                              className="m-portlet__nav-link btn btn-light m-btn m-btn--pill m-btn--air mr-2"
                             >
                                <a
                                 href={ `${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/pdf/${this.props.stateData.petShopReducer.currentPetshop.id}/${mRecord.id}`}    
                                 target="_blank"  
                                 style={{color:"#282a3c",textDecoration:"none"}}
                                >
                                <i className="la la-print"></i>
                                <span>PDF</span>
                                </a>
                            </button>   

                        }                    

                          <button
                            onClick={() => this.editInfo()}
                            className="m-portlet__nav-link btn btn-light m-btn m-btn--pill m-btn--air"
                          >
                            <i className="la la-edit"></i>
                            <span>Edit</span>
                          </button>
                        </div>
                      </div>
                      <div className="m-portlet__body">
                        <div className="m-widget4">
                          <div className="col-md-12">

                            {/* Start : Avatar Image */}
                            <div style={{ width: "100%", display: "inline-flex" }}>                    
                              <div
                                onClick={() => this.next(`/medical-records/${this.props.match.params.next}`)}
                                style={{ margin: "auto", cursor: "pointer" }}>
                                <img
                                  src="../../../assets/app/media/img/navi_buttons/u.png"
                                  style={{ marginTop: "5px" }}
                                />
                              </div>

                              <div style={{ margin: "auto" }}>
                                {mRecord.avatar_path && mRecord.avatar_file_name && !this.state.changeAvatar ? (
                                  <div className="row m--align-center">
                                    <div className={classnames({
                                      "m-widget4__img m-widget4__img--pic my-0": true,
                                      "user-avatar mx-auto": true,
                                      "m-width-100-perc": true
                                    })}>
                                      <img src={
                                        process.env.REACT_APP_S3_PATH +
                                        "/" +
                                        mRecord.avatar_path +
                                        "/" +
                                        mRecord.avatar_file_name
                                      }
                                        alt=""
                                      />
                                    </div>
                                  </div>
                                ) : ""
                                }
                              </div>                          
                              <div
                                style={{ margin: "auto", cursor: "pointer" }}>
                                <img
                                  onClick={() => this.prev(`/medical-records/${(this.props.match.params.prev)}`)}
                                  src="../../../assets/app/media/img/navi_buttons/d.png"
                                  style={{ marginTop: "5px" }}
                                />
                              </div>

                            </div>

                            {/* End : Avatar Image */}

                            {/* Start : Edit Button */}

                            <div className="m--align-center mx-auto mt-2">
                              {!this.state.loadingMultipleImages && this.state.changeAvatar ? (
                                <div className="row">
                                  <div className="col-lg-12 m--align-center">
                                    <input
                                      ref="multipleImageUploader"
                                      type="file"
                                      accept="image/*"
                                      multiple
                                      onChange={this._onChange}
                                    />
                                  </div>

                                  {/* Start : Image 01  */}
                                  {/* {this.state.newImgSrc && (
                                    <div className="col-sm-12 justify-content-center m--align-center mt-5">
                                      <div className="col-xs-10">
                                        <AvatarEditor
                                          ref={this.setNewEditorRef}
                                          image={this.state.newImgSrc}
                                          border={0}
                                          width={200}
                                          height={200}
                                          borderRadius={0}
                                          color={[0, 0, 0, 0.6]} // RGBA
                                          scale={this.state.newZoom}
                                          rotate={this.state.newRotate}
                                        />
                                      </div>
                                      <div className="col-xs-2 d-none d-sm-none d-md-block">
                                        <div className="slider orientation-reversed">
                                            <div className="slider-group">
                                              <div className="slider-vertical">
                                                <Slider
                                                  min={1}
                                                  max={5}
                                                  step={0.1}
                                                  tooltip={false}
                                                  value={this.state.newZoom}
                                                  orientation="vertical"
                                                  onChange={this.changeNewZoom}
                                                />
                                              </div>
                                            </div>
                                        </div>
                                      </div>
                                      <div>
                                        <button
                                          type="button"
                                          className="btn btn-primary m-btn m-btn--icon m-btn--icon-only m-btn--pill mt-2"
                                          onClick={this.changeNewRotate}
                                        >
                                          <i className="la la-rotate-right"></i>
                                        </button>
                                      </div>
                                      <div>
                                        <input type="radio" id="image01" name="primaryImage" value={true} onChange={this.newChangePrimaryImageOption} checked={ this.state.newSelectedPrimaryImageOption } />
                                        <label for="image01" className="ml-2 mb-0">Set as Primary Image</label>
                                      </div>                                                           
                                      <div className="col-xs-2 col-md-4 d-block d-sm-block d-md-none d-lg-none">                                  
                                            <Slider
                                              min={1}
                                              max={5}
                                              step={0.1}
                                              tooltip={false}
                                              value={this.state.newZoom}
                                              onChange={this.changeNewZoom}
                                            />                                  
                                      </div> 
                                      <div className="col-xs-12">
                                        <div className="row justify-content-center m--align-center">
                                          <div className="col-2 mx-1">
                                            <button type="button"
                                              className="btn m-btn--pill btn-outline-warning btn-sm"
                                              onClick={this.resetHandle}> Reset </button> 
                                          </div>
                                          <div className="col-2 mx-1">
                                            <button type="button"
                                              className="btn m-btn--pill btn-outline-success btn-sm"
                                              onClick={this.saveHandle}> Save </button>
                                          </div>
                                        </div>
                                   
                                      </div>
                                    </div>
                                  )} */}
                                 {this.state.newImgSrc && (
                                    <div className="col-sm-12 mt-5 ml-2">
                                      <div className="row justify-content-center">
                                        <div className="col-xs-10">
                                          <AvatarEditor
                                            ref={this.setNewEditorRef}
                                            image={this.state.newImgSrc}
                                            border={0}
                                            width={200}
                                            height={200}
                                            borderRadius={0}
                                            color={[0, 0, 0, 0.6]} // RGBA
                                            scale={this.state.newZoom}
                                            rotate={this.state.newRotate}
                                          />
                                        </div>
                                        <div className="col-xs-2 d-none d-sm-none d-md-block ml-3">
                                        <div className="slider orientation-reversed">
                                            <div className="slider-group">
                                              <div className="slider-vertical">
                                                <Slider
                                                  min={1}
                                                  max={5}
                                                  step={0.1}
                                                  tooltip={false}
                                                  value={this.state.newZoom}
                                                  orientation="vertical"
                                                  onChange={this.changeNewZoom}
                                                />
                                              </div>
                                            </div>
                                        </div>
                                      </div>
                                      </div>  
                                      <div className="row justify-content-center">
                                        <div className="col-xs-2 col-md-4 d-block d-sm-block d-md-none d-lg-none">                                  
                                          <Slider
                                            min={1}
                                            max={5}
                                            step={0.1}
                                            tooltip={false}
                                            value={this.state.newZoom}
                                            onChange={this.changeNewZoom}
                                          />                                  
                                        </div>
                                      </div>                          
                                      <div className="row justify-content-center">
                                        <div className="col-10">
                                          <button
                                            type="button"
                                            className="btn btn-primary m-btn m-btn--icon m-btn--icon-only m-btn--pill mt-2"
                                            onClick={this.changeNewRotate}
                                          >
                                            <i className="la la-rotate-right"></i>
                                          </button>
                                        </div>
                                      </div>                             
                                      <div className="row justify-content-center">
                                        <div className="col-10">
                                          <input type="radio" id="image01" name="primaryImage" value={true} onChange={this.newChangePrimaryImageOption} checked={ this.state.newSelectedPrimaryImageOption } />
                                          <label for="image01" className="ml-2 mb-0">Set as Primary Image</label>
                                        </div>   
                                      </div>
                                      <div className="row justify-content-center mt-3">                                                      
                                        <div className="col-10">
                                          <div className="row justify-content-center">
                                            <div className="col-3 col-offset-3 mx-1">
                                              <button type="button"
                                                className="btn m-btn--pill btn-outline-warning btn-sm"
                                                onClick={this.resetHandle}> Reset </button> 
                                            </div>
                                            <div className="col-3 mx-1">
                                              <button type="button"
                                                className="btn m-btn--pill btn-outline-success btn-sm"
                                                onClick={this.saveHandle}> Save </button>
                                            </div>
                                          </div>
                                    
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  <div className="col-sm-12 mt-4">
                                    <div className="row justify-content-center m--align-center">                              
                                        { this.state.loadedImages && this.state.loadedImages.length> 0 && this.state.loadedImages.map((url,index) => (                                  
                                            <div className="col-xs-4 mt-1 mx-1" onClick={(e) => this.selectHandler(e,url)}>
                                              <div className="profile-image-container">                                          
                                                <img src={url.src} alt="..." style={{width : "80px", height : "80px", cursor:"pointer"}}/>                                                                       
                                             </div>                                      
                                           </div>                                         
                                         ))}                                
                                    </div>
                                  </div>                           

                                  <div className="col-lg-12 m--align-center my-3">
                                    <button
                                      onClick={this.setImagePreview}
                                      type="button"
                                      className="btn m-btn--pill btn-outline-primary">
                                      <i className="fas fa-cloud-upload-alt"></i>{" "}
                                      Upload
                                    </button>
                                  </div>
                                </div>
                              ) : (this.state.loadingMultipleImages ? (
                                <div className="center-row">
                                  <Loader size={50} />
                                </div>
                              ) : (
                                <div>
                                <div className="row justify-content-center">
                                  <div className="col-12">
                                    <button
                                      type="button"
                                      onClick={() => this.changeAvatar()}
                                      className="btn btn-link btn-link-no-deco"
                                      style={{ width: "unset" }}>
                                      <i className="la la-edit"></i>
                                    </button>
                                    <a onClick={()=>{this.changeAvatar()}} style={{ cursor: "pointer", color : "#5867dd", fontWeight : "600" }}>
                                      <span>Replace Profile Pic</span>      
                                    </a> 
                                  </div>
                               </div>
                               {/* <div className="row justify-content-center">
                                  <div className="col-12">
                                    <button
                                      type="button"
                                      onClick={() => this.changeAvatar()}
                                      className="btn btn-link btn-link-no-deco"
                                      style={{ width: "unset" }}>
                                      <i className="la la-trash"></i>
                                    </button>
                                    <a onClick={()=>{this.openProfilePicDeleteModal()}} style={{ cursor: "pointer", color : "#5867dd", fontWeight : "600" }}>
                                      <span>Delete Profile Pic</span>      
                                    </a> 
                                  </div>
                               </div> */}
                                </div>
                                )
                                )}
                            </div>

                              {/* End : Edit Button */}

                            <div className="row">
                              <div className="m-widget4__info mx-auto my-0 mt-2">
                                <span className="m-widget4__title">
                                  {mRecord.Breed.breed_type}
                                </span>
                              </div>
                            </div>
                            <div className="row">
                              <span className="m-badge m-badge--info mx-auto my-0 px-2">
                                <strong>Id: </strong>
                                {mRecord.pet_id}
                              </span>
                            </div>
                            {mRecord.Contract && (
                              <div className="row mt-2">
                                <div className="col-md-12 m--align-center">
                                  <span className="m-badge m-badge--danger m-badge--dot"></span>
                                  <span className="m--font-danger"> Sold</span>
                                  <NavLink
                                    to={`/contracts/${mRecord.Contract.id}`}
                                    className="m-link m-link--info m--font-bold ml-2"
                                  >
                                    View Contract
                                  </NavLink>
                                </div>
                              </div>
                            )}
                                 {/* video uploader start */}
                                 <div className="row mt-2">
                                { this.state.changeVideo && this.state.loadingVideo == false && this.state.videoPlayer == false &&
                                ( <div className="col-lg-12 m--align-center">
                                  <div className="col-lg-12 m--align-center">
                                      <input
                                        ref="videoFile"
                                        type="file"
                                        accept = "video/mp4,video/x-m4v,video/*"    
                                        name="videoFile"                                        
                                        onChange={this.onChangeVideoHandler}
                                      />
                                  </div> 
                                   <div className="col-lg-12 m--align-center my-3">
                                    <button
                                      onClick={this.selectUploader}
                                      type="button"
                                      className="btn m-btn--pill btn-outline-primary">
                                      <i className="fas fa-cloud-upload-alt"></i>{" "}
                                      Upload
                                    </button>
                                  </div>      
                                </div>
                                )}
                                {this.state.loadingVideo && this.state.changeVideo == false && this.state.videoPlayer == false &&
                                <div className="center-row">                          
                                 <Loader size={25} />  
                                </div>}
                                {
                                 this.state.loadingVideo == false && this.state.changeVideo == false && this.state.videoPlayer == true && this.state.videoHoster == videoHoster.wistia && this.state.currentVideoSource == videoHoster.wistia &&
                              
                                   ( <div className="col-12 m--align-center" style={ {fontFamily: 'sans-serif',textAlign: 'center'}}>
                                     <Video embedId = {this.state.updatedVideoUrl} />
                                 
                                    </div>)                            
                                } 
                                {
                                 this.state.loadingVideo == false && this.state.changeVideo == false && this.state.videoPlayer == true && this.state.videoHoster == videoHoster.vimeo && this.state.currentVideoSource == videoHoster.vimeo &&
                              
                                   ( <div className="col-12 m--align-center" style={ {fontFamily: 'sans-serif',textAlign: 'center'}}>
                                    { this.state.vimeoLoaded ?
                                      <Vimeo
                                       video={this.state.updatedVideoUrl}                                       
                                       responsive
                                       sidedock="false" 
                                       onError={(error) => this.disableVimeoPlayer(error)}  
                                      />:
                                        <span className="m-badge m-badge--warning m-badge--wide" style={{fontSize: "12px"}}><strong>Video is processing in background, you may continue…</strong></span>
                                     }
                                    </div>)                            
                                } 
                                {
                                this.state.loadingVideo == false && this.state.changeVideo == false && this.state.videoPlayer && (this.state.videoHoster == this.state.currentVideoSource) && (                       
                                  <div className="col-12 m--align-center">                          
                                    <button
                                      type="button"
                                      onClick={() => this.changeVideo()}
                                      className="btn btn-link btn-link-no-deco"
                                      style={{ width: "unset" }}>
                                      <i className="fa fa-video"></i>                                  
                                      </button> 
                                    <a onClick={()=>{this.changeVideo()}} style={{ cursor: "pointer", color : "#5867dd", fontWeight : "600" }}>
                                      <span>Replace Video</span>     
                                    </a>
                                    <button
                                      type="button"
                                      onClick={(e) => this.removeVideo(e, this.state.updatedVideoId, this.state.mRecord.id)}
                                      className="btn btn-link btn-link-no-deco"
                                      style={{ width: "unset" }}>
                                      <i className="fa fa-trash m--font-danger"></i>                                  
                                    </button> 
                                    <a onClick={(e)=>{this.removeVideo(e, this.state.updatedVideoId, this.state.mRecord.id)}} style={{ cursor: "pointer", fontWeight : "600" }} className="m--font-danger">
                                    <span>Remove Video</span>      
                                    </a>                                            
                                  </div>
                                )          
                               }    
                               {
                                this.state.loadingVideo == false && this.state.changeVideo == false  && ((this.state.videoPlayer && this.state.videoHoster != this.state.currentVideoSource) || this.state.videoPlayer == false) &&                                    
                                <div className="col-12 m--align-center"> 
                                    <button
                                      type="button"
                                      onClick={() => this.changeVideo()}
                                      className="btn btn-link btn-link-no-deco"
                                      style={{ width: "unset" }}>
                                      <i className="fa fa-video"></i>                                
                                    </button> 
                                    <a onClick={()=>{this.changeVideo()}} style={{ cursor: "pointer", color : "#5867dd", fontWeight : "600" }}>
                                     <span>Upload Video</span>      
                                    </a>                     
                                </div>                              
                               }   
                              </div>
                             {/* video uploader end   */}
                          </div>

                          {
                            mRecord.mc_status === 'complete' && !mRecord.Contract && mRecord.woo_pet ?
                              <div className="row">
                                <div className="m-widget4__ext mx-auto my-0 m0-2 mt-2">
                                    <a
                                      onClick={() => this.openWooPageStatusModal()}
                                      className="btn m-btn--pill btn-outline-primary btn-sm"
                                      >
                                      <i className="la la-eye mr-1"></i>
                                      {/* <span>Status : {mRecord.woo_page_status === this.wooPageStatusOptions.Public ? "Visible" : mRecord.woo_page_status === this.wooPageStatusOptions.Finance ? "Private" : mRecord.woo_page_status === this.wooPageStatusOptions.Private ? "Hidden" : "None"}</span> */}
                                      <span>Status : {mRecord.woo_page_status === this.wooPageStatusOptions.Public ? `Visible | ${mRecord.woo_pet_availability ===  this.wooPagePuppyStatusOptions.Available ? "Available" : "Sold" }` : mRecord.woo_page_status === this.wooPageStatusOptions.Finance ? `Private | ${mRecord.woo_pet_availability ===  this.wooPagePuppyStatusOptions.Available ? "Available" : "Sold" }` : mRecord.woo_page_status === this.wooPageStatusOptions.Private ? `Hidden | ${mRecord.woo_pet_availability ===  this.wooPagePuppyStatusOptions.Available ? "Available" : "Sold" }` : "None"}</span>
                                    </a>
                                </div>
                              </div>
                              : ""
                          }
                          
                          <div className="col-md-12">
                            {mRecord.mc_status === "complete" &&
                            !mRecord.Contract &&
                            mRecord.woo_pet &&
                            mRecord.woo_pet_availability === "available" && (
                              <div
                                className="row"
                                style={{ borderBottom: "1px dotted", color: "#e8e4e3" }}
                              >
                                <div className="col-md-6">
                                  <div className="m-widget4__item">
                                    <div
                                      className="m-widget4__info"
                                      style={{ paddingLeft: "0px" }}
                                    >
                                      <span className="m-widget4__sub">
                                        <i className="fas fa-video mr-2"></i>
                                        <span>
                                          <strong>Enable Request for Video Call: </strong>
                                        </span>
                                      </span>
                                    </div>
                                    {mRecord.woo_pet && mRecord.woo_pet_availability === "available" ? (
                                      <div className="m-widget4__ext">
                                        <Switch
                                          onChange={this.changeVideoCallStatus}
                                          checked={this.state.video_call_status}
                                          uncheckedIcon={false}
                                          checkedIcon={false}
                                          onColor={"#34bfa3"}
                                          offColor={"#f4516c"}
                                        />
                                      </div>
                                    ) : (
                                      <div className="m-widget4__ext">
                                        <div className="text-sm"><strong>Not add to Store</strong></div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="m-widget4__item">
                                    <div
                                      className="m-widget4__info"
                                      style={{ paddingLeft: "0px" }}
                                    >
                                      <span className="m-widget4__sub">                                   
                                        <i className="fas fa-chevron-circle-up mr-2"></i>                                   
                                        <span>
                                          <strong>Pin To Top: </strong>
                                        </span>
                                      </span>
                                    </div>                                                          
                                      <div className="m-widget4__ext">                                 
                                        <Switch
                                          onChange={this.changePinToTopStatus}
                                          checked={this.state.pin_to_top_final_status}
                                          uncheckedIcon={false}
                                          checkedIcon={false}
                                          onColor={"#34bfa3"}
                                          offColor={"#f4516c"}
                                        />                               
                                      </div>                                                 
                                  </div>
                                </div>
                              </div>
                            )}           
                            <div className="row">
                              <div className="col-md-6">
                              <div className="m-widget4__item">
                                  <span className="m-widget4__sub">
                                    <i className="fas fa-tag mr-2"></i>
                                    <span>
                                      <strong>Pet's Name: </strong>
                                    </span>
                                    {editInfo ? (
                                      <div className="m-form row">
                                        <div className="col-10">
                                          <input
                                            type="text"
                                            name="pet_name"
                                            onChange={this.changeVal}
                                            className="form-control m-input"
                                            placeholder=""
                                            value={pet_name}
                                          /> 
                                        </div>  
                                        <div className="col-2">
                                        <a                                    
                                          onClick={(e)=> this.openBreedNamesSuggestionModal(e)}               
                                           className="btn btn-outline-success m-btn m-btn--icon m-btn--outline-2x m-btn--icon-only"
                                         >                                      
                                          <i class="fa fa-magic" aria-hidden="true"></i>
                                        </a> 
                                        </div>                                                               
                                      </div>
                                    ) : (
                                        mRecord.pet_name
                                      )}
                                  </span>
                                </div>
                                <div className="m-widget4__item">
                                  <span className="m-widget4__sub">
                                    <i className="fas fa-list-alt mr-2"></i>
                                    <span>
                                      <strong> Personality Description: </strong>
                                    </span>
                                    {editInfo ? (
                                      <div className="m-form row">                                     
                                        <div className="col-10">
                                          <textarea
                                          className="form-control m-input"
                                          name="personality_description"
                                          onChange={this.changeVal}
                                          value={personality_description}
                                          id="exampleTextarea"
                                          rows="5"
                                          ></textarea>                                   
                                         </div> 
                                        <div className="col-2">
                                        <a
                                          className="btn btn-outline-success m-btn m-btn--icon m-btn--outline-2x m-btn--icon-only"
                                          onClick={(e)=> this.openBreedPersonalityDescriptionModal(e)}     
                                        >
                                            <i class="fa fa-magic" aria-hidden="true"></i>    
                                        </a>         
                                         </div> 
                                         <div className="col-lg-12">                                
                                          <div className="text-right">
                                            <span className='complaint-word-count'>{ personality_description && personality_description.trim().length > 0 ? personality_description.trim().length : 0 }/2000</span>
                                          </div>
                                          <div>
                                          <span
                                            className={personality_description && personality_description.trim().length > 2000 ?                                         
                                                    "m-form__help_danger"
                                                    : "display-none"}
                                          >
                                          Description length exceeds maximum
                                          </span>  
                                          </div>
                                        </div>                                       
                                   
                                      </div>
                                    ) : (
                                        <React.Fragment>
                                          {mRecord.personality_description}                                                                      
                                        </React.Fragment>
                                      )}
                                  </span>
                                </div>
                                <div className="m-widget4__item">
                                  <span className="m-widget4__sub">
                                    <i className="fas fa-paw mr-2"></i>
                                    <span>
                                      <strong>Type of Animal: </strong>
                                    </span>
                                    {editInfo ? (
                                      <div className="m-form">
                                        <Select
                                          options={toa}
                                          value={PetId}
                                          name="PetId"
                                          onChange={this.changeToa}
                                          placeholder="Select the type of animal"
                                        />
                                        <span
                                          className={
                                            edit_form.top === null &&
                                              this.state.currentFormNotValid
                                              ? "m-form__help_danger"
                                              : "m-form__help"
                                          }
                                        >
                                          {" "}
                                          Select type of animal
                                        </span>
                                      </div>
                                    ) : (
                                        mRecord.Pet.type
                                      )}
                                  </span>
                                </div>
                                <div className="m-widget4__item">
                                  <span className="m-widget4__sub">
                                    <i className="fas fa-paint-brush mr-2"></i>
                                    <span>
                                      <strong>Color Markings: </strong>
                                    </span>
                                    {editInfo ? (
                                      <div className="m-form">
                                        <input
                                          type="text"
                                          name="color_markings"
                                          onChange={this.changeVal}
                                          className="form-control m-input"
                                          placeholder=""
                                          value={color_markings}
                                        />
                                        <span
                                          className={
                                            edit_form.color_markings === null &&
                                              this.state.currentFormNotValid
                                              ? "m-form__help_danger"
                                              : "m-form__help"
                                          }
                                        >
                                          {" "}
                                          Select color markings
                                        </span>
                                      </div>
                                    ) : (
                                        mRecord.color_markings
                                      )}
                                  </span>
                                </div>
                                <div className="m-widget4__item">
                                  <span className="m-widget4__sub">
                                    <i className="fas fa-microchip mr-2"></i>
                                    <span>
                                      <strong>Microchip: </strong>
                                    </span>
                                    {editInfo ? (
                                      <div className="m-form">
                                        <input
                                          type="text"
                                          name="micro_chip"
                                          onChange={this.changeVal}
                                          className="form-control m-input"
                                          placeholder=""
                                          value={micro_chip}
                                        />
                                        <span
                                          className={
                                            edit_form.micro_chip === null &&
                                              this.state.currentFormNotValid
                                              ? "m-form__help_danger"
                                              : "m-form__help"
                                          }
                                        >
                                          {" "}
                                          Select microchip{" "}
                                        </span>
                                      </div>
                                    ) : (
                                        mRecord.micro_chip
                                      )}
                                  </span>
                                </div>
                                <div className="m-widget4__item">
                                  <span className="m-widget4__sub">
                                    <i className="fas fa-genderless mr-2"></i>
                                    <span>
                                      <strong>Gender: </strong>
                                    </span>
                                    {editInfo ? (
                                      <div className="m-form">
                                        <select
                                          name="sex"
                                          onChange={this.changeSelectionVal}
                                          className="form-control m-input"
                                          placeholder=""
                                          value={sex}
                                        >
                                          <option value="MALE">Male</option>
                                          <option value="FEMALE">Female</option>
                                        </select>
                                        <span
                                          className={
                                            edit_form.sex === null &&
                                              this.state.currentFormNotValid
                                              ? "m-form__help_danger"
                                              : "m-form__help"
                                          }
                                        >
                                          {" "}
                                          Select sex{" "}
                                        </span>
                                      </div>
                                    ) : (
                                        mRecord.sex
                                      )}
                                  </span>
                                </div>
                                <div className="m-widget4__item">
                                  <span className="m-widget4__sub">
                                    <i className="fas fa-weight mr-2"></i>
                                    <span>
                                      <strong>Current weight: </strong>
                                    </span>
                                    {editInfo ? (
                                      <div className="m-form">
                                        <div className="input-group">
                                          <input
                                            type="number"
                                            name="weight"
                                            onChange={this.changeVal}
                                            className="form-control m-input"
                                            placeholder=""
                                            value={weight}
                                          />
                                          <div className="input-group-append">
                                            <span
                                              className="input-group-text"
                                              id="basic-addon2"
                                            >
                                              Lb
                                            </span>
                                          </div>
                                        </div>
                                        <span
                                          className={
                                            edit_form.weight === null &&
                                              this.state.currentFormNotValid
                                              ? "m-form__help_danger"
                                              : "m-form__help"
                                          }
                                        >
                                          {" "}
                                          Select weight{" "}
                                        </span>
                                      </div>
                                    ) : (
                                        <span>{mRecord.weight} Lb</span>
                                      )}
                                  </span>
                                </div>
                                <div className="m-widget4__item">
                                  <span className="m-widget4__sub">
                                    <i className="fas fa-weight mr-2"></i>
                                    <span>
                                      <strong>Adult Weight: </strong>
                                    </span>
                                    {editInfo ? (
                                      <div className="m-form">
                                        <div className="input-group">
                                          <input
                                            type="text"
                                            name="adult_weight"
                                            onChange={this.changeVal}
                                            className="form-control m-input"
                                            placeholder=""
                                            value={adult_weight}
                                          />
                                          <div className="input-group-append">
                                            <span
                                              className="input-group-text"
                                              id="basic-addon2"
                                            >
                                              Lb
                                            </span>
                                          </div>
                                        </div>
                                        <span
                                          className={
                                            edit_form.adult_weight === null &&
                                              this.state.currentFormNotValid
                                              ? "m-form__help_danger"
                                              : "m-form__help"
                                          }
                                        >
                                          {" "}
                                          Select Adult weight{" "}
                                        </span>
                                      </div>
                                    ) : (
                                        <span>{mRecord.adult_weight} Lb</span>
                                      )}
                                  </span>
                                </div>
                                
                                <div className="m-widget4__item">
                                  <span className="m-widget4__sub">
                                    <i className="fas fa-bars mr-2"></i>
                                    <span>
                                      <strong>Registration Type: </strong>
                                    </span>
                                    {editInfo ? (
                                      <div className="m-form">
                                        <Select
                                          options={reg_types}
                                          value={RegistrationTypeId}
                                          name="RegistrationTypeId"
                                          onChange={this.changeRegType}
                                          placeholder="Select the registration type"
                                        />
                                        <span
                                          className={
                                            edit_form.regType === null &&
                                              this.state.currentFormNotValid
                                              ? "m-form__help_danger"
                                              : "m-form__help"
                                          }
                                        >
                                          {" "}
                                          Select registration type{" "}
                                        </span>
                                      </div>
                                    ) : mRecord.Registration_type ? (
                                      mRecord.Registration_type.type
                                    ) : (
                                          "N/A"
                                        )}
                                  </span>
                                </div>
                                <div className="m-widget4__item">
                                  <span className="m-widget4__sub">
                                    <i className="fas flaticon-email mr-2"></i>
                                    <span>
                                      <strong>Email Template: </strong>
                                    </span>
                                    {editInfo ? (
                                      <div className="m-form">
                                        <Select
                                          disabled="disabled"
                                          options={breeds_category}
                                          value={BreedCategoryId}
                                          name="BreedCategoryId"
                                          onChange={this.changeBreedCategory}
                                          placeholder="Select Email Template"
                                        />
                                        <span
                                          className={
                                            edit_form.BreedCategoryId === "none" &&
                                              this.state.currentFormNotValid
                                              ? "m-form__help_danger"
                                              : "m-form__help"
                                          }
                                        >
                                          {" "}
                                          Select welcome email type{" "}
                                        </span>
                                      </div>
                                    ) : mRecord.email_template ? (
                                      mRecord.email_template
                                    ) : (
                                          "N/A"
                                        )}
                                  </span>
                                </div>
                                <div className="m-widget4__item">
                                  <span className="m-widget4__sub">
                                  <i className="fas fa-bars mr-2"></i>
                                    <span>
                                      <strong>Breed Food Type: </strong>
                                      {editInfo ? (
                                        <div className="m-form">
                                           <Select
                                              options={foodTypes}
                                              value={FoodTypeId}
                                              name="FoodTypeId"
                                              onChange={this.changeFoodType}
                                              placeholder="Select Food Type"
                                        />
                                        </div>
                                      ) :(mRecord.FoodType) ? (
                                        mRecord.FoodType.title
                                      ) : (
                                            "N/A"
                                      )}
                                    </span>
                                  </span>
                                </div>
                                <div className="m-widget4__item">
                                {
                                      ( foodTypeImagePath && foodTypeImageName ) ? (
                                        <img style={{maxWidth:"150px",maxHeight:"150px"}}
                                              src={
                                                process.env.REACT_APP_S3_PATH +
                                                "/" +
                                                foodTypeImagePath + "/" + foodTypeImageName
                                              }
                                              alt=""
                                            />   
                                   ) : (null)}
                                </div>                    
                              </div>
                              <div className="col-md-6">
                                <div className="m-widget4__item">
                                  <span className="m-widget4__sub">
                                    <i className="fas fa-id-card mr-2"></i>
                                    <span>
                                      <strong>Pet Id: </strong>
                                    </span>
                                    {editInfo ? (
                                      <div className="m-form row">
                                        <div className="col-lg-8">
                                          <input
                                            type="text"
                                            name="pet_id"
                                            onChange={this.checkPet}
                                            className="form-control m-input"
                                            placeholder=""
                                            value={pet_id}
                                          />
                                        </div>
                                        {this.state.loadingAvailableId || this.loadflag  ?(
                                        <div className="col-lg-2">
                                        <Loader size={25} />
                                        </div>  
                                        ):null}  
                                      <div className="m-form pl-3"> 
                                        <span
                                          className={
                                            edit_form.pet_id === null &&
                                              this.state.currentFormNotValid
                                              ? "m-form__help_danger"
                                              : "m-form__help"
                                          }
                                        >
                                          {" "}
                                          Enter pet id{" "}
                                        </span>
                                      </div>
                                      </div>
                                    ) : (
                                        <React.Fragment>
                                          {mRecord.pet_id}
                                          {mRecord.Contract && (
                                            <span
                                              className="ml-2"
                                              data-container="body"
                                              data-toggle="m-tooltip"
                                              data-placement="top"
                                              title="Pet Id can not be changed for sold pets"
                                            >
                                              <i className="m-form__heading-help-icon flaticon-info"></i>
                                            </span>
                                          )}
                                          {!mRecord.Contract && mRecord.woo_pet && (
                                            <span
                                              className="ml-2"
                                              data-container="body"
                                              data-toggle="m-tooltip"
                                              data-placement="top"
                                              title="Pet Id can not be changed after added to store"
                                            >
                                              <i className="m-form__heading-help-icon flaticon-info"></i>
                                            </span>
                                          )}
                                        </React.Fragment>
                                      )}
                                  </span>
                                </div>
                                <div className="m-widget4__item">
                                  <span className="m-widget4__sub">
                                    <i className="fas fa-venus-mars mr-2"></i>
                                    <span>
                                      <strong>Breed: </strong>
                                    </span>
                                    {editInfo ? (
                                      <div className="m-form">
                                        <Select
                                          options={breeds}
                                          value={BreedId}
                                          name="BreedId"
                                          onChange={this.changeBreed}
                                          placeholder="Select the type of animal"
                                        />
                                        <span
                                          className={
                                            edit_form.breed === null &&
                                              this.state.currentFormNotValid
                                              ? "m-form__help_danger"
                                              : "m-form__help"
                                          }
                                        >
                                          {" "}
                                          Select breed{" "}
                                        </span>
                                      </div>
                                    ) : (
                                        mRecord.Breed.breed_type
                                      )}
                                  </span>
                                </div>
                                {editInfo && BreedId && !BreedCategoryId ? (
                                  <div className="m-widget4__item">
                                    <button type="button" style={{width : "100%"}} className="btn btn-sm m-btn--square  btn-outline-danger m-btn m-btn--outline-1x" onClick={(event) => this.goToSelectedBreedSettings(event)}>EDIT BREED TO ASSIGN EMAIL TEMPLATE</button>
                                  </div> 
                                 ):null}
                                <div className="m-widget4__item">
                                  <span className="m-widget4__sub">
                                    <i className="fas fa-birthday-cake mr-2"></i>
                                    <span>
                                      <strong>Date of Birth: </strong>
                                    </span>
                                    {editInfo ? (
                                      <div className="m-form">
                                        <DatePicker
                                          //dateFormat="MM-DD-YYYY"
                                          selected={dob_picker}
                                          value={dob_picker}
                                          onChange={this.changeDob}
                                          onSelect={this.changeDob}
                                          peekNextMonth
                                          showMonthDropdown
                                          showYearDropdown
                                          dropdownMode="select"
                                        />
                                        {edit_form.dob_range !== null ? (
                                            <span
                                              className={
                                                edit_form.dob === null &&
                                                this.state.currentFormNotValid
                                                  ? "m-form__help_danger"
                                                  : "m-form__help"
                                              }
                                            >
                                              {" "}
                                              Select date of birth{" "}
                                            </span>
                                          ) : (
                                            <span
                                              className={
                                                edit_form.dob_range === null &&
                                                this.state.currentFormNotValid && this.state.showDOBValidateMessage
                                                  ? "m-form__help_danger"
                                                  : "display-none"
                                              }
                                            >
                                              <br /> Invalid date of birth{" "}
                                            </span>
                                          )}
                                      </div>
                                    ) : (
                                        mRecord.date_of_birth
                                      )}
                                  </span>
                                </div>
                               <div className="m-widget4__item">
                                  <span className="m-widget4__sub">
                                    <i className="fas fa-mars mr-2"></i>
                                    <span>
                                      <strong>Sire: </strong>
                                    </span>
                                    {editInfo ? (
                                      <div className="m-form">
                                        <input
                                          type="text"
                                          name="sire"
                                          onChange={this.changeVal}
                                          className="form-control m-input"
                                          placeholder=""
                                          value={sire}
                                        />
                                        <span
                                          className={
                                            edit_form.sire === null &&
                                              this.state.currentFormNotValid
                                              ? "m-form__help_danger"
                                              : "m-form__help"
                                          }
                                        >
                                          {" "}
                                          Select sire{" "}
                                        </span>
                                      </div>
                                    ) : (
                                        mRecord.sire
                                      )}
                                  </span>
                                </div>
                                <div className="m-widget4__item">
                                  <span className="m-widget4__sub">
                                    <i className="fas fa-mars mr-2"></i>
                                    <span>
                                      <strong>Dam: </strong>
                                    </span>
                                    {editInfo ? (
                                      <div className="m-form">
                                        <input
                                          type="text"
                                          name="dam"
                                          onChange={this.changeVal}
                                          className="form-control m-input"
                                          placeholder=""
                                          value={dam}
                                        />
                                        <span
                                          className={
                                            edit_form.dam === null &&
                                              this.state.currentFormNotValid
                                              ? "m-form__help_danger"
                                              : "m-form__help"
                                          }
                                        >
                                          {" "}
                                          Select dam{" "}
                                        </span>
                                      </div>
                                    ) : (
                                        mRecord.dam
                                      )}
                                  </span>
                                </div>
                                <div className="m-widget4__item">
                                  <span className="m-widget4__sub">
                                    <i className="fas fa-ban mr-2"></i>
                                    <span>
                                      <strong>Sire Number: </strong>
                                    </span>
                                    {editInfo ? (
                                      <div className="m-form">
                                        <input
                                          type="text"
                                          name="sire_number"
                                          onChange={this.changeVal}
                                          className="form-control m-input"
                                          disabled={this.state.siredam_disable}
                                          placeholder=""
                                          value={sire_number}
                                        />
                                        <span
                                          className={
                                            edit_form.sire_number === null &&
                                              this.state.currentFormNotValid
                                              ? "m-form__help_danger"
                                              : "m-form__help"
                                          }
                                        >
                                          {" "}
                                          Select sire number{" "}
                                        </span>
                                      </div>
                                    ) : (
                                        mRecord.sire_number
                                      )}
                                  </span>
                                </div>
                                <div className="m-widget4__item">
                                  <span className="m-widget4__sub">
                                    <i className="fas fa-ban mr-2"></i>
                                    <span>
                                      <strong>Dam Number: </strong>
                                    </span>
                                    {editInfo ? (
                                      <div className="m-form">
                                        <input
                                          type="text"
                                          name="dam_number"
                                          onChange={this.changeVal}
                                          className="form-control m-input"
                                          disabled={this.state.siredam_disable}
                                          placeholder=""
                                          value={dam_number}
                                        />
                                        <span
                                          className={
                                            edit_form.dam_number === null &&
                                              this.state.currentFormNotValid
                                              ? "m-form__help_danger"
                                              : "m-form__help"
                                          }
                                        >
                                          {" "}
                                          Select dam number{" "}
                                        </span>
                                      </div>
                                    ) : (
                                        mRecord.dam_number
                                      )}
                                  </span>
                                </div>
                                <div className="m-widget4__item">
                                  <span className="m-widget4__sub">
                                    <i className="fas fa-times-circle mr-2"></i>
                                    <span>
                                      <strong>Cross Breed: </strong>
                                    </span>
                                    {editInfo ? (
                                      <div>
                                        <select
                                          disabled="disabled"
                                          name="cross_breed"
                                          onChange={this.changeSelectionVal}
                                          className="form-control m-input"
                                          placeholder=""
                                          value={cross_breed}
                                        >
                                          <option value="YES">Yes</option>
                                          <option value="NO">No</option>
                                        </select>
                                        <span
                                          className={
                                            edit_form.cross_breed === null &&
                                              this.state.currentFormNotValid
                                              ? "m-form__help_danger"
                                              : "m-form__help"
                                          }
                                        >
                                          {" "}
                                          Select cross breed
                                        </span>
                                      </div>
                                    ) : (
                                        mRecord.cross_breed
                                      )}
                                  </span>
                                </div>
                                <div className="m-widget4__item">
                                  <span className="m-widget4__sub">
                                    <i className="fas fa-dollar-sign mr-2"></i>
                                    <span>
                                      <strong>Price: </strong>
                                    </span>
                                    {editInfo ? (
                                      <div className="m-form">
                                        <div className="col-lg-8 input-group m-input-group pl-0">
                                          <div className="input-group-prepend">
                                            <button className="btn btn-success price-btn-decrement" onClick={this.decrementPrice}>-</button>
                                          </div>
                                          <div className="input-group-prepend">
                                            <span className="input-group-text">
                                              $
                                            </span>
                                          </div>
                                          <input
                                            type="number"           
                                            step={50}                            
                                            value={price > 0 ? price : ""}
                                            onChange={this.changePrice}
                                            className="form-control m-input"                                      
                                            aria-describedby="basic-addon1"
                                          />   
                                          <div className="input-group-prepend">
                                            <button className="btn btn-success price-btn-increment" onClick={this.incrementPrice}>+</button>
                                          </div>                           
                                        </div> 
                                        <span
                                          className={
                                            edit_form.price === null &&
                                              this.state.currentFormNotValid
                                              ? "m-form__help_danger"
                                              : "m-form__help"
                                          }
                                        >
                                          {" "}
                                          Select price{" "}
                                        </span>
                                      </div>
                                    ) : (
                                        mRecord.price
                                      )}
                                  </span>
                                </div>
                                <div className="m-widget4__item">
                                  <span className="m-widget4__sub">
                                    <i className="fas fa-calendar-alt mr-2"></i>
                                    <span>
                                      <strong>Arrival Date: </strong>
                                    </span>
                                    {editInfo ? (
                                      <div className="m-form">
                                       <div className="col-md-12">
                                          <DatePicker
                                            // dateFormat="MM/dd/yyyy"
                                            selected={arrival_date_picker}
                                            value={arrival_date_picker}
                                            onChange={this.changeDate}
                                            onSelect={this.changeDate}
                                          />
                                          <span
                                            className={
                                              edit_form.arrival === null &&
                                                this.state.currentFormNotValid
                                                ? "m-form__help_danger"
                                                : "m-form__help"
                                            }
                                          >
                                            {" "}
                                            Select arrival date
                                          </span> 
                                          </div>                                                                          
                                          <div className="col-md-12">
                                            <strong>Pet's age on arrival : {this.state.petAgeOnArrival}</strong>
                                          </div>

                                          </div> 
                                    ) : (
                                        mRecord.arrival_date
                                      )}
                                  </span>
                                </div>

                                 {edit_form.arrival_date_range === "invalidArrivalDate"  && this.state.validateArrivalDate && 
                                   this.state.currentFormNotValid && this.state.showArrivalDateValidateMessage &&(
                                      <div className="col-md-12 mt-3 col-12 m-form">
                                        <div className="row">        
                                          <div className="col-md-10 col-10 pl-0">
                                            <span className="m-form__help_danger">
                                              Arrival date should be {config.petArrivalDateInWeeksFromDOB} weeks greater than the selected "Date of Birth"
                                            </span>    
                                          </div>
                                          <div className="col-md-2 col-2">
                                            <button type="button" onClick={() => this.skipArrivalDateValidation(false)} style={{float : "right"}} className="btn btn-outline-success btn-sm">Skip</button>
                                          </div>
                                        </div>
                                      </div>
                                      )} 

                              <div className="m-widget4__item">
                                  <span className="m-widget4__sub">
                                    <i className="fas fa-tag mr-2"></i>
                                    <span>
                                      <strong>Pet's Zodiac: </strong>
                                    </span>
                                    {editInfo ? (
                                      <div className="m-form row">
                                        <div className="col-12">
                                          <input
                                            type="text"
                                            name="pet_zodiac"
                                            onChange={this.changeVal}
                                            className="form-control m-input"
                                            placeholder=""
                                            disabled
                                            value={pet_zodiac}
                                          /> 
                                        </div>                                    
                                      </div>
                                    ) : (
                                        mRecord.pet_zodiac
                                      )}
                                  </span>
                                </div>
                                <div className="m-widget4__item">
                                  <span className="m-widget4__sub">
                                    <i className="fas fa-list-alt mr-2"></i>
                                    <span>
                                      <strong> Zodiac Description: </strong>
                                    </span>
                                    {editInfo ? (
                                      <div className="m-form row">                                     
                                        <div className="col-10">
                                          <textarea
                                          className="form-control m-input"
                                          name="pet_zodiac_description"
                                          onChange={this.changeVal}
                                          value={pet_zodiac_description}
                                          id="exampleTextarea"
                                          rows="5"
                                          ></textarea>                                   
                                         </div> 
                                        <div className="col-2">
                                        <a
                                          className="btn btn-outline-success m-btn m-btn--icon m-btn--outline-2x m-btn--icon-only"
                                          onClick={(e)=> this.openZodiacDescriptionModal(e)}     
                                        >
                                            <i class="fa fa-magic" aria-hidden="true"></i>    
                                        </a>         
                                         </div> 
                                         <div className="col-lg-12">                                
                                          <div className="text-right">
                                            <span className='complaint-word-count'>{ pet_zodiac_description && pet_zodiac_description.trim().length > 0 ? pet_zodiac_description.trim().length : 0 }/500</span>
                                          </div>
                                          <div>
                                          <span
                                            className={pet_zodiac_description && pet_zodiac_description.trim().length > 500 ?                                         
                                                    "m-form__help_danger"
                                                    : "display-none"}
                                          >
                                          Description length exceeds maximum
                                          </span>  
                                          </div>
                                        </div>                                       
                                   
                                      </div>
                                    ) : (
                                        <React.Fragment>
                                          {mRecord.pet_zodiac_description}                                                                      
                                        </React.Fragment>
                                      )}
                                  </span>
                                </div>
                                </div>

                              </div>
                            </div><div className="col-md-12">
                          </div>
                          {editInfo && this.state.loadingInfo == false && (
                            <div className="col-md-12">
                              <div className="row  justify-content-end mt-4">
                                <div className="m-widget4__ext">
                                  <a
                                    onClick={() => this.cancelEditInfo()}
                                    className="btn m-btn--pill btn-secondary btn-sm"
                                  >
                                    Cancel
                                  </a>
                                </div>
                                <div className="m-widget4__ext">
                                  <a
                                    onClick={(e) => this.saveInfo()}
                                    className="btn m-btn--pill btn-outline-primary btn-sm mx-2"
                                  >
                                    Save
                                  </a>
                                </div>
                              </div>
                            </div>
                          )}
                          {editInfo && this.state.loadingInfo && (
                            <div className="center-row">
                              <Loader size={50} />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div
                      className="m-portlet m-portlet--success m-portlet--head-solid-bg"
                      style={{ boxShadow: "none" }}
                    >
                      <div className="m-portlet__head">
                        <div className="m-portlet__head-caption">
                          <div className="m-portlet__head-title">
                            <h3 className="m-portlet__head-text">
                              Breeder Information
                            </h3>
                          </div>
                        </div>
                        <div className="m-portlet__head-tools">
                          <button
                            onClick={() => this.editBreeder()}
                            className="m-portlet__nav-link btn btn-light m-btn m-btn--pill m-btn--air"
                          >
                            <i className="la la-edit"></i>
                            <span>Edit</span>
                          </button>
                        </div>
                      </div>
                      <div className="m-portlet__body">
                        <div className="m-widget4">
                          {editBreeder && (
                            <div className="col-xl-10 px-0 pb-4">
                              <label className="m-checkbox m-checkbox--bold m-checkbox--state-success">
                                <input
                                  onChange={this.toggleBreeder}
                                  value={new_breeder}
                                  checked={new_breeder}
                                  type="checkbox"
                                />{" "}
                                New Breeder
                                <span></span>
                              </label>
                            </div>
                          )}
                          {!new_breeder ? (
                            <div>
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-id-card mr-2"></i>
                                  <span>
                                    <strong>Breeder: </strong>
                                  </span>
                                  {!editBreeder &&
                                    mRecord.Breeder !== null &&
                                    mRecord.Breeder.breeder}
                                </span>
                                {editBreeder && (
                                  <div className="form-group m-form__group mb-0">
                                    <Select
                                      options={breeders}
                                      value={BreederId}
                                      name="BreederId"
                                      onChange={this.changeBreeder}
                                      placeholder="Select the breeder"
                                    />
                                    {/* {BreederId} */}
                                  </div>
                                )}
                              </div>
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-genderless mr-2"></i>
                                  <span>
                                    <strong>USDA Number: </strong>
                                  </span>
                                  {!editBreeder
                                    ? mRecord.Breeder !== null &&
                                    mRecord.Breeder.usda_no
                                    : b_usda}
                                </span>
                              </div>
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-paw mr-2"></i>
                                  <span>
                                    <strong>Address Line 1: </strong>
                                  </span>
                                  {!editBreeder
                                    ? mRecord.Breeder !== null &&
                                    mRecord.Breeder.addressLine1
                                    : b_address_line_1}
                                </span>
                              </div>
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-paw mr-2"></i>
                                  <span>
                                    <strong>Address Line 2: </strong>
                                  </span>
                                  {!editBreeder
                                    ? mRecord.Breeder !== null &&
                                    mRecord.Breeder.addressLine2
                                    : b_address_line_2}
                                </span>
                              </div>
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-paw mr-2"></i>
                                  <span>
                                    <strong>City: </strong>
                                  </span>
                                  {!editBreeder
                                    ? mRecord.Breeder !== null &&
                                    mRecord.Breeder.addressCity
                                    : b_address_city}
                                </span>
                              </div>
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-paw mr-2"></i>
                                  <span>
                                    <strong>State/Province: </strong>
                                  </span>
                                  {!editBreeder
                                    ? mRecord.Breeder !== null &&
                                    mRecord.Breeder.addressState
                                    : b_address_state}
                                </span>
                              </div>
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-paw mr-2"></i>
                                  <span>
                                    <strong>Country: </strong>
                                  </span>
                                  {!editBreeder
                                    ? mRecord.Breeder !== null &&
                                    mRecord.Breeder.addressCountry
                                    : b_address_country}
                                </span>
                              </div>
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-paw mr-2"></i>
                                  <span>
                                    <strong>Postal Code: </strong>
                                  </span>
                                  {!editBreeder
                                    ? mRecord.Breeder !== null &&
                                    mRecord.Breeder.addressPostalCode
                                    : b_address_postal_code}
                                </span>
                              </div>
                              <div className="m-widget4__item">
                                <span className="m-widget4__sub">
                                  <i className="fas fa-birthday-cake mr-2"></i>
                                  <span>
                                    <strong>Phone: </strong>
                                  </span>
                                    {!editBreeder
                                      ? mRecord.Breeder !== null &&
                                      <a href={`tel:${mRecord.Breeder.phone}`} className="hyperlink-phone-number">
                                        {mRecord.Breeder.phone}
                                      </a>
                                      : b_phone}
                                </span>
                              </div>
                            </div>
                          ) : (
                              <div>
                                <div className="m-widget4__item">
                                  <span className="m-widget4__sub">
                                    <i className="fas fa-id-card mr-2"></i>
                                    <span>
                                      <strong> Breeder: </strong>
                                    </span>
                                    <div className="m-form">
                                      <input
                                        type="text"
                                        value={new_b_name}
                                        name="new_b_name"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                      />
                                      <span
                                        className={
                                          breeder_form.breeder === null &&
                                            this.state.currentFormNotValid
                                            ? "m-form__help_danger"
                                            : "m-form__help"
                                        }
                                      >
                                        Enter the breeder name
                                    </span>
                                    </div>
                                  </span>
                                </div>
                                <div className="m-widget4__item">
                                  <span className="m-widget4__sub">
                                    <i className="fas fa-genderless mr-2"></i>
                                    <span>
                                      <strong> USDA Number: </strong>
                                    </span>
                                    <div className="m-form">
                                      <input
                                        type="text"
                                        value={new_b_usda}
                                        name="new_b_usda"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                      />
                                      <span
                                        className={
                                          breeder_form.usda_no === null &&
                                            this.state.currentFormNotValid
                                            ? "m-form__help_danger"
                                            : "m-form__help"
                                        }
                                      >
                                        Enter the USDA number
                                    </span>
                                    </div>
                                  </span>
                                </div>
                                <div className="m-widget4__item">
                                  <span className="m-widget4__sub">
                                    <i className="fas fa-paw mr-2"></i>
                                    <span>
                                      <strong>Address Line 1: </strong>
                                    </span>
                                    <div className="m-form">
                                      <input
                                        type="text"
                                        value={new_b_address_line_1}
                                        name="new_b_address_line_1"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                      />
                                      <span
                                        className={
                                          breeder_form.address_line_1 === null &&
                                            this.state.currentFormNotValid
                                            ? "m-form__help_danger"
                                            : "m-form__help"
                                        }
                                      >
                                        Enter the breeder's address line 1
                                    </span>
                                    </div>
                                  </span>
                                </div>
                                <div className="m-widget4__item">
                                  <span className="m-widget4__sub">
                                    <i className="fas fa-paw mr-2"></i>
                                    <span>
                                      <strong>Address Line 2: </strong>
                                    </span>
                                    <div className="m-form">
                                      <input
                                        type="text"
                                        value={new_b_address_line_2}
                                        name="new_b_address_line_2"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                      />
                                      <span
                                        className={
                                          breeder_form.address_line_2 === null &&
                                            this.state.currentFormNotValid
                                            ? "m-form__help_danger"
                                            : "m-form__help"
                                        }
                                      >
                                        Enter the breeder's address line
                                        2(Optional)
                                    </span>
                                    </div>
                                  </span>
                                </div>
                                <div className="m-widget4__item">
                                  <span className="m-widget4__sub">
                                    <i className="fas fa-paw mr-2"></i>
                                    <span>
                                      <strong> City: </strong>
                                    </span>
                                    <div className="m-form">
                                      <input
                                        type="text"
                                        value={new_b_address_city}
                                        name="new_b_address_city"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                      />
                                      <span
                                        className={
                                          breeder_form.address_city === null &&
                                            this.state.currentFormNotValid
                                            ? "m-form__help_danger"
                                            : "m-form__help"
                                        }
                                      >
                                        Enter the breeder's address city
                                    </span>
                                    </div>
                                  </span>
                                </div>
                                <div className="m-widget4__item">
                                  <span className="m-widget4__sub">
                                    <i className="fas fa-paw mr-2"></i>
                                    <span>
                                      <strong> State/Province: </strong>
                                    </span>
                                    <div className="m-form">
                                      <input
                                        type="text"
                                        value={new_b_address_state}
                                        name="new_b_address_state"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                      />
                                      <span
                                        className={
                                          breeder_form.address_state === null &&
                                            this.state.currentFormNotValid
                                            ? "m-form__help_danger"
                                            : "m-form__help"
                                        }
                                      >
                                        Enter the breeder's address state
                                    </span>
                                    </div>
                                  </span>
                                </div>
                                <div className="m-widget4__item">
                                  <span className="m-widget4__sub">
                                    <i className="fas fa-paw mr-2"></i>
                                    <span>
                                      <strong> Country: </strong>
                                    </span>
                                    <div className="m-form">
                                      <input
                                        type="text"
                                        value={new_b_address_country}
                                        name="new_b_address_country"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                      />
                                      <span
                                        className={
                                          breeder_form.address_country === null &&
                                            this.state.currentFormNotValid
                                            ? "m-form__help_danger"
                                            : "m-form__help"
                                        }
                                      >
                                        Enter the breeder's address country
                                    </span>
                                    </div>
                                  </span>
                                </div>
                                <div className="m-widget4__item">
                                  <span className="m-widget4__sub">
                                    <i className="fas fa-paw mr-2"></i>
                                    <span>
                                      <strong> Postal Code: </strong>
                                    </span>
                                    <div className="m-form">
                                      <input
                                        type="text"
                                        value={new_b_address_postal_code}
                                        name="new_b_address_postal_code"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                      />
                                      <span
                                        className={
                                          breeder_form.address_postal_code ===
                                            null && this.state.currentFormNotValid
                                            ? "m-form__help_danger"
                                            : "m-form__help"
                                        }
                                      >
                                        Enter the breeder's address postal code
                                    </span>
                                    </div>
                                  </span>
                                </div>
                                <div className="m-widget4__item">
                                  <span className="m-widget4__sub">
                                    <i className="fas fa-birthday-cake mr-2"></i>
                                    <span>
                                      <strong>Phone: </strong>
                                    </span>
                                    <div className="m-form">
                                      <input
                                        type="text"
                                        value={new_b_phone}
                                        name="new_b_phone"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                      />
                                      <span
                                        className={
                                          breeder_form.phone === null &&
                                            this.state.currentFormNotValid
                                            ? "m-form__help_danger"
                                            : "m-form__help"
                                        }
                                      >
                                        Enter the breeder's phone
                                    </span>
                                    </div>
                                  </span>
                                </div>
                              </div>
                            )}

                          {editBreeder && this.state.loadingBreeder == false && (
                            <div className="col-md-12">
                              <div className="row  justify-content-end mt-4">
                                <div className="m-widget4__ext">
                                  <a
                                    onClick={() => this.cancelEditBreeder()}
                                    className="btn m-btn--pill btn-secondary btn-sm"
                                  >
                                    Cancel
                                  </a>
                                </div>

                                <div className="m-widget4__ext">
                                  <a
                                    onClick={() => this.saveBreeder()}
                                    className="btn m-btn--pill btn-outline-primary btn-sm mx-2"
                                  >
                                    Save
                                  </a>
                                </div>
                              </div>
                            </div>
                          )}
                          {editBreeder && this.state.loadingBreeder && (
                            <div className="center-row">
                              <Loader size={50} />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div
                      className="m-portlet m-portlet--success m-portlet--head-solid-bg"
                      style={{ boxShadow: "none" }}
                    >
                      {mRecord.woo_pet && !mRecord.Contract && (
                        <div className="m-portlet__head">
                          <div className="m-portlet__head-tools">
                            <button
                              onClick={() => this.fetchContract()}
                              className="m-portlet__nav-link btn btn-light m-btn m-btn--pill m-btn--air">
                              <i className="la la-arrow-circle-o-down"></i>
                              <span className="ml-1">Fetch Contract</span>
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-xs-12 col-sm-8 col-md-8 col-lg-5">
                  <div className="m-portlet m-portlet--full-height">
                    <div
                      className="m-portlet m-portlet--success m-portlet--head-solid-bg"
                      style={{
                        boxShadow: "none",
                        height: "30%",
                        overflowY: scroll
                      }}
                    >
                      <div className="m-portlet__head">
                        <div className="m-portlet__head-caption">
                          <div className="m-portlet__head-title">
                            <h3 className="m-portlet__head-text">
                              Vaccinations
                            </h3>
                          </div>
                        </div>
                      </div>
                      <div className="m-portlet__body">
                        <PerfectScrollbar style={{ paddingRight: "25px" }}>
                          <div
                            className="m-accordion m-accordion--default"
                            id="m_accordion_4"
                            role="tablist"
                          >
                            {mRecord.MedicalRecordMedications.length > 0
                              ? mRecord.MedicalRecordMedications.filter(p => {
                                return p.Medication.type === "vaccine";
                              }).map((p, i) => (
                                <div
                                  className="m-accordion__item overlay-visible"
                                  key={i}
                                >
                                  <div
                                    className="m-accordion__item-head collapsed"
                                    role="tab"
                                    id={"m_accordion_4_item_" + i + "_head"}
                                    data-toggle="collapse"
                                    href={
                                      "#m_accordion_4_item_" + i + "_body"
                                    }
                                    aria-expanded="    false"
                                  >
                                    <span className="m-accordion__item-icon">
                                      <i className="fas fa-syringe"></i>
                                    </span>
                                    {p.Medication.type === "vaccine" ? (
                                      <span className="m-accordion__item-title">
                                        {" "}
                                          Vaccination {i + 1} -{" "}
                                        {p.Medication.name}{" "}
                                      </span>
                                    ) : p.Medication.type === "deworm" ? (
                                      <span className="m-accordion__item-title">
                                        {" "}
                                          Treatment {i + 1} -{" "}
                                        {p.Medication.name}
                                      </span>
                                    ) : null}
                                    <span className="m-accordion__item-mode"></span>
                                  </div>
                                  <div
                                    className="m-accordion__item-body collapse"
                                    id={"m_accordion_4_item_" + i + "_body"}
                                    role="tabpanel"
                                    aria-labelledby={
                                      "m_accordion_4_item_" + i + "_head"
                                    }
                                    data-parent="#m_accordion_4"
                                  >
                                    <div className="m-accordion__item-content">
                                      <div className="m-widget4">
                                        <div className="m-widget4__item">
                                          <span className="m-widget4__sub">
                                            <i className="fas fa-calendar-alt mr-2"></i>
                                            <span>
                                              <strong>Date Administered: </strong>
                                            </span>
                                            {p.date}
                                          </span>
                                        </div>
                                        <div className="m-widget4__item">
                                          <span className="m-widget4__sub">
                                            <i className="fas fa-clipboard-check mr-2"></i>
                                            <span>
                                              <strong>Vaccination Name: </strong>
                                            </span>
                                            {p.Medication.name}
                                          </span>
                                        </div>
                                        <div className="m-widget4__item">
                                          <span className="m-widget4__sub">
                                            <i className="fas fa-info-circle mr-2"></i>
                                            <span>
                                              <strong>Notes (Serial, Expiration, Etc.): </strong>
                                            </span>
                                            {p.more_info}
                                          </span>
                                        </div>
                                        <div className="m-widget4__item m--align-right">
                                          <span className="m-widget4__sub">
                                            <a
                                              href="#"
                                              onClick={() =>
                                                this.openConfirmModal(p.id)
                                              }
                                              className="btn m-btn--pill btn-outline-danger btn-sm mx-2"
                                            >
                                              <span>
                                                <i className="la la-minus-circle mr-2"></i>
                                                <span>Delete</span>
                                              </span>
                                            </a>
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))
                              : null}
                          </div>
                          <div className="mt-2 mb-3" style={{ float: "right" }}>
                            <a
                              href="#"
                              className="btn btn-outline-primary m-btn m-btn--icon m-btn--pill"
                              onClick={event =>
                                this.newMedication(event, "vaccine")
                              }
                            >
                              <span>
                                <i className="la la-plus"></i>
                                <span>New Vaccination</span>
                              </span>
                            </a>
                          </div>
                        </PerfectScrollbar>
                      </div>
                    </div>
                    <div
                      className="m-portlet m-portlet--success m-portlet--head-solid-bg"
                      style={{
                        boxShadow: "none",
                        height: "30%",
                        overflowY: scroll
                      }}
                    >
                      <div className="m-portlet__head">
                        <div className="m-portlet__head-caption">
                          <div className="m-portlet__head-title">
                            <h3 className="m-portlet__head-text">Treatments
                              <small>
                                Dewormings, Surgeries, Etc.
                              </small>
                            </h3>
                          </div>
                        </div>
                      </div>
                      <div className="m-portlet__body">
                        <PerfectScrollbar style={{ paddingRight: "25px" }}>
                          <div
                            className="m-accordion m-accordion--default"
                            id="m_accordion_5"
                            role="tablist"
                          >
                            {mRecord.MedicalRecordMedications.length > 0
                              ? mRecord.MedicalRecordMedications.filter(p => {
                                return p.Medication.type === "deworm";
                              }).map((p, i) => (
                                <div
                                  className="m-accordion__item overlay-visible"
                                  key={i}
                                >
                                  <div
                                    className="m-accordion__item-head collapsed"
                                    role="tab"
                                    id={"m_accordion_5_item_" + i + "_head"}
                                    data-toggle="collapse"
                                    href={
                                      "#m_accordion_5_item_" + i + "_body"
                                    }
                                    aria-expanded="    false"
                                  >
                                    <span className="m-accordion__item-icon">
                                      <i className="fas fa-syringe"></i>
                                    </span>
                                    {p.Medication.type === "vaccine" ? (
                                      <span className="m-accordion__item-title">
                                        {" "}
                                          Vaccination {i + 1} -{" "}
                                        {p.Medication.name}{" "}
                                      </span>
                                    ) : p.Medication.type === "deworm" ? (
                                      <span className="m-accordion__item-title">
                                        {" "}
                                          Treatment {i + 1} -{" "}
                                        {p.Medication.name}
                                      </span>
                                    ) : null}
                                    <span className="m-accordion__item-mode"></span>
                                  </div>
                                  <div
                                    className="m-accordion__item-body collapse"
                                    id={"m_accordion_5_item_" + i + "_body"}
                                    role="tabpanel"
                                    aria-labelledby={
                                      "m_accordion_5_item_" + i + "_head"
                                    }
                                    data-parent="#m_accordion_4"
                                  >
                                    <div className="m-accordion__item-content">
                                      <div className="m-widget4">
                                        <div className="m-widget4__item">
                                          <span className="m-widget4__sub">
                                            <i className="fas fa-calendar-alt mr-2"></i>
                                            <span>
                                              <strong>Date Administered: </strong>
                                            </span>
                                            {p.date}
                                          </span>
                                        </div>
                                        <div className="m-widget4__item">
                                          <span className="m-widget4__sub">
                                            <i className="fas fa-clipboard-check mr-2"></i>
                                            <span>
                                              <strong>Vaccination Name: </strong>
                                            </span>
                                            {p.Medication.name}
                                          </span>
                                        </div>
                                        <div className="m-widget4__item">
                                          <span className="m-widget4__sub">
                                            <i className="fas fa-info-circle mr-2"></i>
                                            <span>
                                              <strong>Notes (Serial, Expiration, Etc.): </strong>
                                            </span>
                                            {p.more_info}
                                          </span>
                                        </div>
                                        <div className="m-widget4__item m--align-right">
                                          <span className="m-widget4__sub">
                                            <a
                                              href="#"
                                              onClick={() =>
                                                this.openConfirmModal(p.id)
                                              }
                                              className="btn m-btn--pill btn-outline-danger btn-sm mx-2"
                                            >
                                              <span>
                                                <i className="la la-minus-circle mr-2"></i>
                                                <span>Delete</span>
                                              </span>
                                            </a>
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))
                              : null}
                          </div>
                          <div className="mt-2 mb-3" style={{ float: "right" }}>
                            <a
                              href="#"
                              className="btn btn-outline-primary m-btn m-btn--icon m-btn--pill"
                              onClick={event =>
                                this.newMedication(event, "deworm")
                              }
                            >
                              <span>
                                <i className="la la-plus"></i>
                                <span>New Treatment</span>
                              </span>
                            </a>
                          </div>
                        </PerfectScrollbar>
                      </div>
                    </div>
                    <div
                      className="m-portlet m-portlet--success m-portlet--head-solid-bg"
                      style={{
                        boxShadow: "none",
                        height: "30%",
                        overflowY: scroll
                      }}
                    >
                      <div className="m-portlet__head">
                        <div className="m-portlet__head-caption">
                          <div className="m-portlet__head-title">
                            <h3 className="m-portlet__head-text">Notes</h3>
                          </div>
                        </div>
                        <div className="m-portlet__head-tools">
                          <button
                            onClick={() => this.editNote()}
                            className="m-portlet__nav-link btn btn-light m-btn m-btn--pill m-btn--air"
                          >
                            <i className="la la-edit"></i>
                            <span>Edit</span>
                          </button>
                        </div>
                      </div>
                      <div
                        className="m-portlet__body"
                        style={{ minHeight: "100%" }}
                      >
                        <div className="row">
                          <div className="col-md-12">
                            {!editNote ? (
                              mRecord.notes
                            ) : (
                                <div className="m-form">
                                  <textarea
                                    className="form-control m-input"
                                    name="notes"
                                    onChange={this.changeVal}
                                    value={notes}
                                    id="exampleTextarea"
                                    rows="3"
                                  ></textarea>
                                  <span className="m-form__help">
                                    {" "}
                                  Enter the note{" "}
                                  </span>
                                </div>
                              )}
                          </div>
                          {editNote && this.state.loadingNote == false && (
                            <div className="col-md-12">
                              <div className="row  justify-content-end mt-4">
                                <div className="m-widget4__ext">
                                  <a
                                    onClick={() => this.cancelEditNote()}
                                    className="btn m-btn--pill btn-secondary btn-sm"
                                  >
                                    Cancel
                                  </a>
                                </div>
                                {BreederId !== "N/A" && (
                                  <div className="m-widget4__ext">
                                    <a
                                      onClick={() => this.saveNote()}
                                      className="btn m-btn--pill btn-outline-primary btn-sm mx-2"
                                    >
                                      Save
                                    </a>
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                          {editNote && this.state.loadingNote && (
                            <div className="center-row">
                              <Loader size={50} />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        :                    
        <div className={"loader-center"}>
          <Loader
            type="line-scale"
            active={true}
            className="loader-center"
          />
        </div>
        }

        {/* models */}
        <div
          className="modal fade"
          id="confirm_delete_modal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="ConfirmationModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Confirm to delete
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete this vaccination?</p>
              </div>
              <div className="modal-footer">
                {this.state.loadingDelete == false ? (
                  <div>
                    <button
                      type="button"
                      className="btn btn-secondary m-btn--pill mx-2"
                      data-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      onClick={() => this.deleteMedication()}
                      className="btn btn-primary m-btn--pill"
                    >
                      Confirm
                    </button>
                  </div>
                ) : (
                    <div className="center-row">
                      <Loader size={50} />
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="confirm_store_modal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="ConfirmationModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Confirm to add this pet to store
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p>
                  Are you sure you want to add this pet to your store?
                </p>

                <input type="checkbox" name="notifySubscribers" checked={this.state.notifySubscribers}   onChange={(e) => {
                    this.handleChange({
                      target: {
                        name: 'notifySubscribers',
                        value: e.target.checked,
                      },
                    });
                  }}/> <label>Notify subscribers of the changes</label>
              </div>
              <div className="modal-footer">
                {this.state.loadingStore == false ? (
                  <div>
                    <button
                      type="button"
                      className="btn btn-secondary m-btn--pill mx-2"
                      data-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      onClick={() => this.addtoStore()}
                      className="btn btn-primary m-btn--pill"
                    >
                      Confirm
                    </button>
                  </div>
                ) : (
                    <div className="center-row">
                      <Loader size={50} />
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="send_notification_model"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="ConfirmationModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Confirm to send notifications
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={e => this.cancelProcess()}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p>
                Do you want to notify subscribers of these changes?
                </p>
              </div>
              <div className="modal-footer">
                {!this.state.loadingStore || !this.state.loadingWooPageStatus? (
                  <div>
                    { this.state.priceUpdate ? 
                      <div>
                        <button
                          type="button"
                          className="btn btn-secondary m-btn--pill mx-2"
                          onClick={() => this.completeUpdateMedicalRecord(false)}
                        >
                          No
                        </button>
                        <button
                          type="button"
                          onClick={() => this.completeUpdateMedicalRecord(true)}
                          className="btn btn-primary m-btn--pill"
                        >
                          Yes
                        </button>
                      </div> 
                    : ""}

                    { this.state.avatarUpdate ? 
                      <div>
                        <button
                          type="button"
                          className="btn btn-secondary m-btn--pill mx-2"
                          onClick={() => this.completeUpdateAvatar(false)}
                        >
                          No
                        </button>
                        <button
                          type="button"
                          onClick={() => this.completeUpdateAvatar(true)}
                          className="btn btn-primary m-btn--pill"
                        >
                          Yes
                        </button>
                      </div> 
                    : ""}

                    { this.state.soldReason && soldReasonValues.find(record => (record.key === this.state.soldReason && record.notify === true))  ? 
                      <div>
                        <button
                          type="button"
                          className="btn btn-secondary m-btn--pill mx-2"
                          onClick={() => this.setWooPageStatus(false)}
                        >
                          No
                        </button>
                        <button
                          type="button"
                          onClick={() => this.setWooPageStatus(true)}
                          className="btn btn-primary m-btn--pill"
                        >
                          Yes
                        </button>
                      </div> 
                    : ""}
                    
                  </div>
                ) : (
                    <div className="center-row">
                      <Loader size={50} />
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="woo_page_status_modal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="ConfirmationModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Current Status
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="my-3">
                  <input type="radio" id="privateWooPageStatus" name="privateWooPageStatus" value={this.wooPageStatusOptions.Private} onChange={this.changeWooPageStatusOption} checked={this.state.selectedWooPageStatusOption === this.wooPageStatusOptions.Private} />
                  <label htmlFor="privateWooPageStatus" className="ml-2 mb-0">Hidden</label>
                  {
                    this.state.selectedWooPageStatusOption === this.wooPageStatusOptions.Private ? 
                    <div className="m-radio-inline">
                      <label className="m-radio mb-0 ml-3 mt-2">
                          <input type="radio" name="petAvailability" checked={this.state.selectedWooPagePuppyStatusOption === this.wooPagePuppyStatusOptions.Available } onChange={this.changeWooPagePuppyStatusOption} value={this.wooPagePuppyStatusOptions.Available} /> {" "}Available
                          <span></span>
                      </label>
                      <label className="m-radio mb-0 ml-3 mt-2">
                          <input type="radio" name="petAvailability" checked={this.state.selectedWooPagePuppyStatusOption === this.wooPagePuppyStatusOptions.Sold } onChange={this.changeWooPagePuppyStatusOption} value={this.wooPagePuppyStatusOptions.Sold} /> {" "}Sold
                          <span></span>
                      </label>
                      {this.state.selectedWooPagePuppyStatusOption === this.wooPagePuppyStatusOptions.Sold ? 
                        <>
                          <select className="form-select" onChange={this.handleChange} name="soldReason" value={soldReason}>
                            <option hidden value={null} style={{display: "none"}}>Select Reason</option>
                            {soldReasonValues.map( row => {
                              return <option value={row.key} selected={soldReason === row.key ? true : false}>{row.value}</option>
                            })
                            }
                          </select>
                          <span className="invalid-feedback" style={{display: this.state.customFormNotValid ? "block": "none"}}>Please select reason.</span>
                        </>
                        :
                        ""
                      }
                      
                    </div>
                    : ""
                  }
                </div>
                <div className="my-3">
                  <input type="radio" id="publicWooPageStatus" name="publicWooPageStatus" value={this.wooPageStatusOptions.Public} onChange={this.changeWooPageStatusOption} checked={this.state.selectedWooPageStatusOption === this.wooPageStatusOptions.Public} />
                  <label htmlFor="publicWooPageStatus" className="ml-2 mb-0">Visible</label>
                  {
                    this.state.selectedWooPageStatusOption === this.wooPageStatusOptions.Public ? 
                    <div className="m-radio-inline">
                        <label className="m-radio mb-0 ml-3 mt-2">
                            <input type="radio" name="petAvailability" checked={this.state.selectedWooPagePuppyStatusOption === this.wooPagePuppyStatusOptions.Available } onChange={this.changeWooPagePuppyStatusOption} value={this.wooPagePuppyStatusOptions.Available} /> {" "}Available
                            <span></span>
                        </label>
                        <label className="m-radio mb-0 ml-3 mt-2">
                            <input type="radio" name="petAvailability" checked={this.state.selectedWooPagePuppyStatusOption === this.wooPagePuppyStatusOptions.Sold } onChange={this.changeWooPagePuppyStatusOption} value={this.wooPagePuppyStatusOptions.Sold} /> {" "}Sold
                            <span></span>
                        </label>
                        {this.state.selectedWooPagePuppyStatusOption === this.wooPagePuppyStatusOptions.Sold ? 
                        <>
                          <select className="form-select" onChange={this.handleChange} name="soldReason" value={soldReason}>
                            <option hidden value={null} style={{display: "none"}}>Select Reason</option>
                            {soldReasonValues.map( row => {
                              return <option value={row.key} selected={soldReason === row.key ? true : false}>{row.value}</option>
                            })
                            }
                          </select>
                          <span className="invalid-feedback" style={{display: this.state.customFormNotValid ? "block": "none"}}>Please select reason.</span>
                        </>
                        :
                        ""
                      }
                    </div>
                    : ""
                  }
                </div>
                <div className="my-3">
                  <input type="radio" id="financeWooPageStatus" name="financeWooPageStatus" value={this.wooPageStatusOptions.Finance} onChange={this.changeWooPageStatusOption} checked={this.state.selectedWooPageStatusOption === this.wooPageStatusOptions.Finance} />
                  <label htmlFor="financeWooPageStatus" className="ml-2 mb-0">Private Link</label>
                  {
                    this.state.selectedWooPageStatusOption === this.wooPageStatusOptions.Finance ? 
                    <div className="m-radio-inline">
                      <label className="m-radio mb-0 ml-3 mt-2">
                          <input type="radio" name="petAvailability" checked={this.state.selectedWooPagePuppyStatusOption === this.wooPagePuppyStatusOptions.Available } onChange={this.changeWooPagePuppyStatusOption} value={this.wooPagePuppyStatusOptions.Available} /> {" "}Available
                          <span></span>
                      </label>
                      <label className="m-radio mb-0 ml-3 mt-2">
                          <input type="radio" name="petAvailability" checked={this.state.selectedWooPagePuppyStatusOption === this.wooPagePuppyStatusOptions.Sold } onChange={this.changeWooPagePuppyStatusOption} value={this.wooPagePuppyStatusOptions.Sold} /> {" "}Sold
                          <span></span>
                      </label>
                      {this.state.selectedWooPagePuppyStatusOption === this.wooPagePuppyStatusOptions.Sold ? 
                        <>
                          <select className="form-select" onChange={this.handleChange} name="soldReason" value={soldReason}>
                            <option hidden value={null} style={{display: "none"}}>Select Reason</option>
                            {soldReasonValues.map( row => {
                              return <option value={row.key} selected={soldReason === row.key ? true : false}>{row.value}</option>
                            })
                            }
                          </select>
                          <span className="invalid-feedback" style={{display: this.state.customFormNotValid ? "block": "none"}}>Please select reason.</span>
                        </>
                        :
                        ""
                      }
                    </div>
                    : ""
                  }
                </div>
              { 
                mRecord.woo_page_status === this.wooPageStatusOptions.Finance && this.state.selectedWooPageStatusOption === this.wooPageStatusOptions.Finance ?   
                <div>        
                  <div className="mb-2">
                    <span className="m-widget4__sub">
                      <i className="la la-link mr-2"></i>
                      <span>
                        <strong>Link: </strong>
                      </span>
                    </span>
                  </div>

                  <div className="row  justify-content-end mt-4">

                    <div className="col-md-10 pr-0">
                      <div className="m-widget4__ext">
                      <input
                          type="text"
                          name="woo_permalink"
                          onChange={this.changeVal}
                          className="form-control m-input"
                          placeholder=""
                          disabled={true}
                          value={mRecord.woo_permalink}
                        />
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="m-widget4__ext">
                        <button
                          type="button"
                          onClick={() => this.copyWooPageUrl()}
                          className="btn btn-primary m-btn--pill"
                        >
                          Copy
                        </button>
                      </div>
                    </div>

                  </div>
                </div>
                : ""
              }

              </div>

              <div className="modal-footer">
                {this.state.loadingWooPageStatus == false ? (
                  <div>
                    <button
                      type="button"
                      className="btn btn-secondary m-btn--pill mx-2"
                      data-dismiss="modal"
                    >
                      Close
                    </button>
                    {soldReason && soldReasonValues.find(record => (record.key === soldReason && record.notify === true) && this.state.availableSubscribers.length > 0 && this.state.mRecord.Contract === null) ? 
                      <button
                        type="button"
                        onClick={() => this.changeStateOfSoldPopUp()}
                        className="btn btn-primary m-btn--pill"
                        >
                        Update
                      </button>
                      :
                      <button
                        type="button"
                        onClick={() => this.setWooPageStatus()}
                        className="btn btn-primary m-btn--pill"
                        >
                        Update
                      </button>
                    }
                    
                  </div>
                ) : (
                    <div className="center-row">
                      <Loader size={50} />
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="confirm_delete_video_modal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="ConfirmationModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Confirm to delete the video
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete the video?</p>
              </div>
              <div className="modal-footer">
                {this.state.loadingDeleteVideo === false ? (
                  <div>
                    <button
                      type="button"
                      className="btn btn-secondary m-btn--pill mx-2"
                      data-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      onClick={(e) => this.confirmAndDeleteVideo(e)}
                      className="btn btn-primary m-btn--pill"
                    >
                      Confirm
                    </button>
                  </div>
                ) : (
                    <div className="center-row">
                      <Loader size={50} />
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="pet_pin_to_top_modal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="SectionSelectModalLabel"
          aria-hidden="true"
         >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                   Pin Top In Website
                </h5>
                <button
                          type="button"
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                </button>
              </div>
            { isPinToTop ?
              <div className="modal-body">
                  Move puppy <strong>({this.state.mRecord.pet_id})</strong> to first position in website?
              </div>:
              <div className="modal-body">
                  Remove puppy <strong>({this.state.mRecord.pet_id})</strong> from first position in website?
              </div>
            }

              <div className="modal-footer">
                      {loadingPinToTop ? (
                        <Loader size={50} />
                      ) : (
                        <div>
                          <button
                            type="button"
                            className="btn btn-secondary m-btn--pill mx-2"
                            data-dismiss="modal"
                          >
                            No
                          </button>
                          <button
                            type="button"
                            onClick={(e) => this.handlePinToTopQueue(e)}
                            className="btn btn-primary m-btn--pill"
                          >
                            Yes
                          </button>
                        </div>
                      )}
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="image-resize-model"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="ConfirmationModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Preview Images
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"                
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">

                <div className="row justify-content-center">
            
                 { this.state.loadedImages && this.state.loadedImages.length > 0 && this.state.loadedImages[0] && this.state.loadedImages[0].src && (
                  <div className="col-4">
                     <AvatarEditor
                        ref={this.setEditorRef01}
                        image={this.state.loadedImages[0] ? this.state.loadedImages[0].src: null}
                        border={0}
                        width={125}
                        height={125}
                        borderRadius={0}
                        color={[0, 0, 0, 0.6]} // RGBA
                        scale= {1}
                        rotate={this.state.rotate01}
                      />                      

                  </div>
                  )} 
                  {  this.state.loadedImages && this.state.loadedImages.length > 0 && this.state.loadedImages[1] && this.state.loadedImages[1].src && (
                  <div className="col-4">
                     <AvatarEditor
                        ref={this.setEditorRef02}
                        image={this.state.loadedImages[1] ? this.state.loadedImages[1].src: null}
                        border={0}
                        width={125}
                        height={125}
                        borderRadius={0}
                        color={[0, 0, 0, 0.6]} // RGBA
                        scale={1}
                        rotate={this.state.rotate02}
                      />

                  </div>
                )}
                 {  this.state.loadedImages && this.state.loadedImages.length > 0 && this.state.loadedImages[2] && this.state.loadedImages[2].src && (
                  <div className="col-4">
                     <AvatarEditor
                        ref={this.setEditorRef03}
                        image={this.state.loadedImages[2] ? this.state.loadedImages[2].src: null}
                        border={0}
                        width={125}
                        height={125}
                        borderRadius={0}
                        color={[0, 0, 0, 0.6]} // RGBA
                        scale={1}
                        rotate={this.state.rotate03}
                      />

                  </div>
                )} 
                </div>
                <div className="row justify-content-center">            
                    {  this.state.loadedImages && this.state.loadedImages.length > 0 && this.state.loadedImages[3] && this.state.loadedImages[3].src && (
                    <div className="col-4">
                        <AvatarEditor
                          ref={this.setEditorRef04}
                          image={this.state.loadedImages[3] ? this.state.loadedImages[3].src: null}
                          border={0}
                          width={125}
                          height={125}
                          borderRadius={0}
                          color={[0, 0, 0, 0.6]} // RGBA
                          scale={1}
                          rotate={this.state.rotate01}
                        />                      

                    </div>
                    )} 
                    {  this.state.loadedImages && this.state.loadedImages.length > 0 && this.state.loadedImages[4] && this.state.loadedImages[4].src && (
                    <div className="col-4">
                        <AvatarEditor
                          ref={this.setEditorRef05}
                          image={this.state.loadedImages[4] ? this.state.loadedImages[4].src: null}
                          border={0}
                          width={125}
                          height={125}
                          borderRadius={0}
                          color={[0, 0, 0, 0.6]} // RGBA
                          scale={1}
                        rotate={this.state.rotate02}
                        />

                    </div>
                  )}
                    {  this.state.loadedImages && this.state.loadedImages.length > 0 && this.state.loadedImages[5] && this.state.loadedImages[5].src && (
                    <div className="col-4">
                        <AvatarEditor
                          ref={this.setEditorRef06}
                          image={this.state.loadedImages[5] ? this.state.loadedImages[5].src: null}
                          border={0}
                          width={125}
                          height={125}
                          borderRadius={0}
                          color={[0, 0, 0, 0.6]} // RGBA
                          scale={1}
                          rotate={this.state.rotate03}
                        />

                    </div>
                  )} 
               </div>  
               <div className="row justify-content-center">            
                    {  this.state.loadedImages && this.state.loadedImages.length > 0 && this.state.loadedImages[6] && this.state.loadedImages[6].src && (
                    <div className="col-4">
                        <AvatarEditor
                          ref={this.setEditorRef07}
                          image={this.state.loadedImages[6] ? this.state.loadedImages[6].src: null}
                          border={0}
                          width={125}
                          height={125}
                          borderRadius={0}
                          color={[0, 0, 0, 0.6]} // RGBA
                          scale = {1}
                          rotate={this.state.rotate01}
                        />                      

                    </div>
                    )} 
                    {  this.state.loadedImages && this.state.loadedImages.length > 0 && this.state.loadedImages[7] && this.state.loadedImages[7].src && (
                    <div className="col-4">
                        <AvatarEditor
                          ref={this.setEditorRef08}
                          image={this.state.loadedImages[7] ? this.state.loadedImages[7].src: null}
                          border={0}
                          width={125}
                          height={125}
                          borderRadius={0}
                          color={[0, 0, 0, 0.6]} // RGBA
                          scale={1}
                          rotate={this.state.rotate02}
                        />

                    </div>
                  )}
                    {  this.state.loadedImages && this.state.loadedImages.length > 0 && this.state.loadedImages[8] && this.state.loadedImages[8].src && (
                    <div className="col-4">
                        <AvatarEditor
                          ref={this.setEditorRef09}
                          image={this.state.loadedImages[8] ? this.state.loadedImages[8].src: null}
                          border={0}
                          width={125}
                          height={125}
                          borderRadius={0}
                          color={[0, 0, 0, 0.6]} // RGBA
                          scale={1}
                          rotate={this.state.rotate03}
                        />

                    </div>
                  )} 
               </div> 
               <div className="row justify-content-center">            
                    {  this.state.loadedImages && this.state.loadedImages.length > 0 && this.state.loadedImages[9] && this.state.loadedImages[9].src && (
                    <div className="col-4">
                        <AvatarEditor
                          ref={this.setEditorRef10}
                          image={this.state.loadedImages[9] ? this.state.loadedImages[9].src: null}
                          border={0}
                          width={125}
                          height={125}
                          borderRadius={0}
                          color={[0, 0, 0, 0.6]} // RGBA
                          scale = {1}
                          rotate={this.state.rotate01}
                        />                      

                    </div>
                    )}             
        
               </div>          
              </div>
              <div className="modal-footer">           
                    <button
                      type="button"
                      className="btn btn-secondary m-btn--pill mx-2"
                      data-dismiss="modal"
                    >
                          Cancel
                    </button>
                    <button
                          type="button"
                          onClick={() => this.saveAvatar()}
                          className="btn btn-primary m-btn--pill"
                        >
                          Upload
                    </button>              
                      
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="delete_profile_pic"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="SectionSelectModalLabel"
          aria-hidden="true"             
         >
          <div className="modal-dialog modal-md" role="document">
            <div className="modal-content">
               <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                      Puppy Image Delete Confirmation
                  </h5> 
                  <button
                    type="button"
                     className="close"
                     data-dismiss="modal"
                     aria-label="Close"
                      >
                     <span aria-hidden="true">&times;</span>
                  </button>
              </div> 
              <div className="modal-body">      
                <div class="m-widget4">
                  {/* Test start  */}
                   <div className="row">
                      <div className="col-12">
                        <p>Only 9 puppy images and 1 video is allowed. Please select a image to delete.</p>
                      </div>
                    </div>                                        
                    <div className="row">
                      { this.state.uploadedImages && this.state.uploadedImages.map((item,keyindex) =>(  
                         <div className="col-4 " key={keyindex}> 
                           <div className="row justify-content-center">  
                              <div className="col-8">               
                                <img 
                                  src={
                                  process.env.REACT_APP_S3_PATH +
                                  "/" + item.imagePath +
                                  "/" + item.imageName
                                  } 
                                  alt=""
                                  style={{width : "80px", height : "80px"}}                         
                                />
                              </div>
                           </div>
                           <div className="row justify-content-center">  
                              <div className="col-6 mt-2">      
                                  <input type="radio" name="deleteImage" onClick={()=>this.selectPuppyImageDelete(item)} value={item.id} className="ml-4" />
                                {/* <button
                                  type="button"
                                  onClick={() => this.openDeleteConfirmModal(item)}
                                  className="btn btn-link btn-link-no-deco ml-4"
                                  style={{ width: "unset" }}>
                                  <i className="la la-trash"></i>
                                </button> */}
                               </div>
                              </div>                      
                            </div>                    
                        ))                 
                        }
                     </div>                  
                </div>             
              </div>
              <div className="modal-footer">
              {/* { this.state.deletingImage &&                      
                    <div className="center-row">
                      <Loader size={50} />
                    </div>
               } */}

              {this.state.deletingImage == false ? (
                  <div>
                    <button
                      type="button"
                      className="btn btn-secondary m-btn--pill mx-2"
                      data-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      onClick={() => this.openDeleteConfirmModal()}
                      className="btn btn-primary m-btn--pill"
                      >
                      Delete
                    </button>
                  </div>
                ) : (
                    <div className="center-row">
                      <Loader size={50} />
                    </div>
                  )}
          
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="confirm_delete_profile_image_modal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="ConfirmationModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Confirm to delete
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"                
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p>
                Do you want to delete the image?
                </p>
              </div>
              <div className="modal-footer">           
                    <button
                      type="button"
                      className="btn btn-secondary m-btn--pill mx-2"
                      data-dismiss="modal"
                    >
                          No
                    </button>
                        <button
                          type="button"
                          onClick={() => this.deleteAvatar()}
                          className="btn btn-primary m-btn--pill"
                        >
                          Yes
                    </button>              
                      
              </div>
            </div>
          </div>
        </div>

        <AddMedicationForm mrId={mRecord.id} mediType={mediModalType} />
        {this.state.clickedId ? <MRecordPDF setClick={this.acceptMethods.bind(this)} unmountMe={this.handleChildUnmount.bind(this)} /> : null}
        {/* <MRecordPDF setClick={this.acceptMethods.bind(this)} /> */}
        <AddBreedTypeForm selectedBreedData={this.state.selectedBreedData}  actionBreed={this.handlerBreedData}/>
        <PetNameSuggestion petNamePrompt={this.state.namePrompt} parentPetNameCallback={this.handlePetNameChildResponse} />
        <PetDescriptionSuggestion petDescriptionPrompt={this.state.descriptionPrompt} parentPetDescriptionCallback={this.handlePetDescriptionResponse} />
        <PetZodiacDescriptionSuggestion petZodiacDescriptionPrompt={this.state.zodiacDescriptionPrompt} parentPetZodiacDescriptionCallback={this.handlePetZodiacDescriptionResponse} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.cognito.user,
  data: state.medicalRecordsReducer,
  breeders: state.breederReducer.breederList,
  toa: state.addAnimalTypeReducer.animalTypes,
  breeds: state.addBreedTypeReducer.breedsByAnimal,
  reg_types: state.regTypeReducer.regTypes,
  toaError: state.addAnimalTypeReducer.animalTypesError,
  reg_types_error: state.regTypeReducer.regTypesError,
  mRecordsError: state.medicalRecordsReducer.mRecordsError,
  breederListError: state.breederReducer.breederListError,
  breeds_category: state.breederReducer.breederCategory,
  breedInfo : state.addBreedTypeReducer.breedInfo,
  foodTypes : state.foodTypeReducer.foodTypes,
  updatedBreedTypeById : state.addBreedTypeReducer.updatedBreedTypeById,
  configStatus : state.configReducer.configStatus,
  stateData : state,
  pinToTopQueue : state.medicalRecordsReducer.pinToTopQueue,
  pinToTopQueueError : state.medicalRecordsReducer.pinToTopQueueError,
});

const mapDispatchToProps = dispatch => ({
  showMedicalRecord: id => {
    dispatch(showMedicalRecord(id));
  },
  fetchMedicalRecords: () => {
    dispatch(fetchMedicalRecords());
  },
  fetchBreeders: () => {
    dispatch(fetchBreeders());
  },
  fetchAdministereds: () => {
    dispatch(fetchAdministereds());
  },
  fetchAnimalTypes: () => {
    dispatch(fetchAnimalTypes());
  },
  fetchBreedTypesByAnimal: animal => {
    dispatch(fetchBreedTypesByAnimal(animal));
  },
  fetchRegTypes: () => {
    dispatch(fetchRegTypes());
  },
  deleteMedication: id => {
    dispatch(deleteMedication(id));
  },
  updateMedicalRecord: (id, data) => {
    dispatch(updateMedicalRecord(id, data));
  },
  fetchContractFromWooStore: data => {
    dispatch(fetchContractFromWooStore(data));
  },
  attachAvatar: (id, data) => {
    dispatch(attachMRAvatar(id, data));
  },
  updatePrintMRecord: id => {
    dispatch(updatePrintMRecord(id));
  },
  createWooPet: (id, notifySubscribers) => {
    dispatch(createWooPet(id, notifySubscribers));
  },
  fetchBreedCategory: () => {
    dispatch(fetchBreedCategory());
  },
  fetchFoodTypes : () => {
    dispatch(fetchFoodTypes());
  },
  updateWooPageStatus: (id, data) => {
    dispatch(updateWooPageStatus(id, data));
  },
  findPetById: data => {
    dispatch(findPetById(data));
  },
  fetchBreedInfo : id => {
    dispatch(fetchBreedInfo(id));
  },
  fetchUpdatedBreedTypeById : id => {
    dispatch(fetchUpdatedBreedTypeById(id));
  },
  getNotificationsByMedicalRecord: id => {
    dispatch(getNotificationsByMedicalRecord(id));
  },
  getConfigByName: (data) => {
    dispatch(getConfigByName(data));
  },
  removePuppyVideo: (data) => {
    dispatch(removePuppyVideo(data));
  },
  updateVideoCallStatus: (id, data) => {
    dispatch(updateVideoCallStatus(id, data));
  },
  petPinToTop: (id,status)=> {
    dispatch(petPinToTop(id,status));
  },
  deleteProfileImage: (id,data) => {
    dispatch(deleteProfileImage(id, data));
  },
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MRecordsListView)
);
